import React, { useState, useEffect, useRef, useMemo, useCallback, useImperativeHandle } from 'react'
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule, themeBalham } from 'ag-grid-community';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import Theme from "../components/Theme";
import MainMenu from "../components/MainMenu";
import Header from "../components/Header";
import AGFunction from "../components/AGFunction";
import ComFunction from "../components/ComFunction";
import {
    isEmpty, getWindowDimensions, storageKey, getcontinuekey, getcookie, setglobaldata, Interval, storageExistsKey, customTarget,
    Getstorage, isEnabled, setcookie, DeepCopy, getglobaldata, RandomKey, GetExtension, NumConv, replaceall, toStringYYYY,
    tagformat, removeDuplicates, removetag, toStringDate, toStringYM, isDate, FormatDate, toHalfWidth, trim, isNumber, PadZero, getFirstDigits,
    numformat, DicVal, selectformat, stickynote, stickymark, stickycolor, CellType, Floor, Eval, StringConv, Loadstorage, getInteferPointLength
} from '../modules/appLibrary';
import { setmenus, resetstore } from '../modules/menustore';
import {
    changestatus, setmenuinfo, clearform, clearform2, success, warnning, setstoragename, setprestorage, themestyle,
    gridtabvalue, setctrl, resetform, setchangeurl, listtabs as setListTabs, listoption as setListOption
} from '../modules/formstore';
import { settoolpanel, addlayout } from '../modules/toolpanelstore';
import { Backdrop } from '@material-ui/core';
import { Snackbar  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import StatusNav from "../components/StatusNav";
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import SearchList from '../components/SearchList';
import SearchSKU from '../components/SearchSKU';
import StickyList from '../components/StickyList';
import DatePicker from '../components/DatePicker';
import ColorPicker from '../components/ColorPicker';
import WashPicker from '../components/WashPicker';
import ListEditRenderer from "./RenderListEdit.js";
import TagRenderer from "./RenderTag.js";
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import SearchPanel from "../components/SearchPanel";
import Chip from '@material-ui/core/Chip';
import MsgBox from "../components/MsgBox";
import { continueinfo } from '../modules/userstore';
import ImageDialog from "../components/ImageDialog";
import GridTab from "./GridTab.js";
import CustomToolPanel from "../components/CustomToolPanel";
import CustomToolorgPanel from "../components/CustomToolorgPanel";
import MasonryForm from "../components/MasonryForm";
import FormDlg from "../components/FormDialog";
import Popuptext from "../components/Popuptext";
import EntryBase from "../components/EntryBase";
import WaitCursor from "../components/WaitCursor";

// 必要なモジュールを登録
ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: 10000,
        color: '#fff',
    },
    root: {
        display: 'flex',
        padding: '0 10px',
        height:30,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    chip: {
        margin: theme.spacing(0.2),
    },
    snackbarStyleViaContentProps: {
        backgroundColor: "#6ac86f"
    },
    snackbaredittool: {
        backgroundColor: "#F8F8F8",
        color:"#000"
    },
    label: {
        fontSize: "12px"
    },
}));

const OP = {
    LIST: 0,
    ENTRY:1
}

const { forwardRef } = React;

//---------------------------------------------------------------------
//  マスタページコンポーネント
//
//  controller
//  location
//  actionurl : コマンド実行URL
//  uploaded  : FileUpload CallBack
//  condition : 検索条件 true:有 false:無  未使用
//  entryform : true:有 false:無
//  tabs      : TabList有無
//  show      : show
//  primaryid : INSERT時subtableの主キーdataid
//  primarykey: 主キー項目名 FileUpload時使用
//  navmenu   : 拡張メニュ
//  suppressaction : 抑止動作
//  lockcell  : Lockセル取得用コールバック
//  slipsave  : True:明細Insert
//  list      : True:List
//  noclear   : True:list=trueで項目変更時データクリアしない
//  exRowStyle: RowStyle拡張
//  blank     : True:空
//  entryonly : EntryFormのみ
//  notshowndata : True:データ表示なし
//  insertonly: True:INSERT ONLY
//  usecondition: True:CONDITIONモード使用
//  queryexecute : List実行前処理
//  setcondition: 検索条件設定処理
//  updatelockuncheck: true=UPDATEで編集可否項目のテーブルチェックを行わない
//  changevalue : 変更イベントコールバック
//  QuerySearchlistOpen: 検索リストOPEN前処理
//  tabvalueChange:タブ変更時イベント
//---------------------------------------------------------------------
//  処理仕様
//
//  ・検索TAGはconst参照できない為JSのglobalへ保存
//  ・GetList直後のrowDataはJSのglobalへ保存。AGgrid.contextへセットし変更セル取得に使用
//  ・前回開いた保存データ名はcookie保存
//  ・EntryForm更新→View時子テーブルListの場合再表示
//---------------------------------------------------------------------
const MasterLayout = forwardRef(function MasterLayout(props, ref) {

    const colDefsInit = { field: 'rowid', colId: 'rowid', initialHide: true, hide: true, suppressColumnsToolPanel: true, filter: false };

    const gridRef = useRef();
    const AGRef = useRef();
    const fnc = useRef();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const uploadRef = useRef(null);
    const upload2Ref = useRef(null);
    const menus = useSelector(state => state.menu.menus);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const formstatus = useSelector(state => state.form.status);
    const readonly = useSelector(state => state.form.readonly);
    const ctrls = useSelector(state => state.form.ctrls);
    const modify = useSelector(state => state.form.modify);
    const entrylock = useSelector(state => state.form.entryformlock);
    const wait = useSelector(state => state.form.wait);
    const waitcursor = useSelector(state => state.form.waitcursor);
    const resultsuccess = useSelector(state => state.form.success);
    const resultwarnning = useSelector(state => state.form.warnning);
    const warnmessage = useSelector(state => state.form.warnmessage);
    const warndescription = useSelector(state => state.form.warndiscription);
    const successmsg = useSelector(state => state.form.successmsg);
    const reports = useSelector(state => state.form.reports);
    const selectopen = useSelector(state => state.search.open);
    const selectrowid = useSelector(state => state.search.rowid);
    const storagename = useSelector(state => state.form.storagename);
    const storageupdate = useSelector(state => state.form.storageupdate);
    const prestoragename = useSelector(state => state.form.prestoragename);
    const mainfitColumn = useSelector(state => state.toolpnl.fitColumn);
    const callstatus = useSelector(state => state.form.callstatus);
    const opentheme = useSelector(state => state.form.opentheme);
    const formstyle = useSelector(state => state.form.themestyle);
    const listtabs = useSelector(state => state.form.listtabs);
    const listoption = useSelector(state => state.form.listoption);
    const admin = useSelector(state => state.user.authority);
    const showlimit = useSelector(state => state.toolpnl.showlimit);
    const history = useHistory();
    const dispatch = useDispatch();
    const Suppress = useRef(false);

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報

    const [dbupdate, setdbupdate] = useState(false);        //true:DB更新
    const [fileimp, setfileimp] = useState(false);          //true:ファイル取込
    const [agtheme, setagtheme] = useState(null);
    const [bodytheme, setbodytheme] = useState({ 'back': '#F8F8F8', 'color': '#000' });

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [columns, setcolumns] = useState([colDefsInit]);
    const [title, settitle] = useState("no title");
    const [category, setcategory] = useState("");
    const [gridContext, setContext] = useState({ status: "VIEW" });
    const [menuopen, setmenuopen] = useState(false);
    const [searchitems, setsearchitems] = useState([]);     //検索リスト項目
    const [searchword, setsearchword] = useState("");
    const [searchtaglist, setsearchtaglist] = useState([]);
    const [tabvalue, settabvalue] = React.useState('0');      //選択TAG (Table)
    const [listtype, setlisttype] = React.useState('');       //List種別 基本的にはlisttype=tabvalue
    const [imgdlgopen, setimgdlgopen] = useState(false);
    const [rowHeight, setRowHeight] = useState(null);
    const [entryrow, setentryrow] = useState([]);
    const [showinit, setshowinit] = useState(false);
    const [edittool, setedittool] = useState(0);    //0:OFF 1:検索 2:置換
    const [Defaultrange, setDefaultrange] = useState(false);
    const [listlock, setlistlock] = useState(false);
    const [isoption, setisoption] = useState(false);
    const [optpanel, setoptpanel] = useState(null);
    const [ajustH, setajustH] = useState(100);
    const [searchpanelopen, setsearchpanelopen] = useState(false);
    const [navmenu, setnavmenu] = useState([]);
    const [condition, setcondition] = useState(false);
    const [mysave, setmysave] = useState(false);
    const [hiddencmd, sethiddencmd] = useState(null);
    const [conditionCancelEnabled, setConditionCancelEnabled] = useState(false);
    const [listInfoLoaded, setListInfoLoaded] = useState(false);
    const [notshowstatus, setnotshowstatus] = useState(false);

    const directionRef = useRef();      //検索向き
    const matchRef = useRef();          //完全一致
    const rangeRef = useRef();          //範囲検索
    const findwordRef = useRef();       //検索ワード
    const replacewordRef = useRef();    //置換ワード

    const scrollLeftRef = useRef();     //スクロール位置
    const historyRef = useRef(false);   //true:他画面からの遷移
    const storageRef = useRef();        //保存データ情報
    const entrymodifyRef = useRef(false);   //true:追加または更新
    const popstateRef = useRef(false);  //ブラウザバック制御用
    const listtypeRef = useRef(-1);     //表示ListType
    const redrawRowsTimerRef = useRef(null);
    const listoptionRef = useRef(null); //ListOptionデータ
    const listoptionViewSnapshotRef = useRef(null);   //VIEW復帰時のListOption退避
    const pendingInsertOnlyClearRef = useRef(false);   //insertOnly初期化時のClearSheet保留
    const initialConditionStatusRef = useRef(false);   //true:起動時CONDITION適用済み
    const cancelReturnStatusRef = useRef(null);   //CANCEL時の復帰先

    const classes = useStyles();
    const formid = props.formid;
    const storekey = formid + "_store";  //DataSource保存キー
    const tagkey = formid + "_tag";      //Search Tagキー
    const condkey = formid + "_cond";    //検索条件キー
    const colfixkey = formid + "_colfix"; //列幅最適化
    const stickykey = formid + "_sticky"; //StickyFieldId
    const RowNodeId = data => data.rowid;
    const CELLTYPE = CellType();
    const search = useLocation().search;
    const isViewStatus = formstatus === "VIEW" || formstatus === "CONDITION";
    const isListStatus = isViewStatus || formstatus === "UPDATE" || formstatus === "INSERT" || formstatus === "MASONRY";
    const listoptionFields = useMemo(() => {
        if (isEmpty(listoption)) return [];
        if (!isEnabled(props.usecondition)) return listoption;
        return listoption.map(field => {
            if (field.headerfix === 1 || field.unchange) return field;        //レイアウト切替OPTION Or Lock対象外
            return {
                ...field,
                locked: field.locked || formstatus !== "CONDITION"
            };
        });
    }, [listoption, props.usecondition, formstatus]);

    const icons = useMemo(() => {
        return {
            'custom-tools': '<i class="material-icons min">star</i>',
            'custom-tools2': '<i class="material-icons min">table_chart</i>',
        };
    }, []);

    useImperativeHandle(ref, () => ({
        ApiRef() {
            return AGRef.current;
        },
        //選択データを取得
        GetSelectrowdata() {
            if (isEmpty(AGRef.current)) return;
            return AGRef.current.GetSelectrowdata();
        },
        //表示中データを取得
        GetAfterFilterData() {
            if (isEmpty(AGRef.current)) return;
            return AGRef.current.GetAfterFilterData();
        },
        //メニュの変更
        ChangeNavmenu(newmenu) {
            setnavmenu(newmenu);
        },
        //リスト種別取得
        ListType() {
            const currentListType = isEmpty(listtype) ? GetListType() : listtype;
            return currentListType.toString();
        },
        //リストオプション情報取得
        ListOption() {
            return listoptionRef.current;
        },
        //検索条件取得
        ListCondition() {
            return getglobaldata(condkey);
        },
        //ListOptionの表示/非表示
        ListOptionShow(mode) {
            setisoption(mode);
        },
        //Statusに対する非表示コマンド
        hideMenucmd(cmd) {
            sethiddencmd(cmd);
        },
        //リスト実行
        ListExecute(initial) {
            GetList(initial);
        },
        //ナビメニュステータスの表示有無(true:表示なし)
        NotShowStatus(status) {
            setnotshowstatus(status);
        }
    }));

    function storagekey(tab) {
        if (isEmpty(tab))
            return formid + "_" + tabvalue;
        else
            return formid + "_" + tab;
    }
    function prestoragenamekey() {
        return storageKey(corpkey, account, "strnamekey_" + formid);
    }

    function updateGridContext(newContext) {
        setContext(prev => ({
            ...prev,
            ...newContext
        }));
    }
    function IsStatusSuppress(cmd) {
        switch (cmd) {
            case "UPDATE":
                cmd = "NAV1"; break;
            case "INSERT":
                cmd = "NAV2"; break;
            case "NEW FORM":
                cmd = ["NAV3", "NAV4"]; break;
            case "ENTRY FORM":
                cmd = ["NAV7", "NAV4"]; break;
            case "MASONRY":
                cmd = "NAV5"; break;
            default:
                break;
        }
        if (typeof cmd === "string")
            return ctrls.indexOf(cmd) !== -1;
        for (let i = 0; i < cmd.length; i++) {
            if (ctrls.indexOf(cmd[i]) !== -1) return true;
        }
        return false;
    }
    function isInsertOnly() {
        if (isEnabled(props.entryonly)) return false;

        let showupdate = !IsStatusSuppress("UPDATE");
        let showinsert = !IsStatusSuppress("INSERT");
        let shownew = true;
        let showentry = true;

        if (!isEmpty(props.suppressaction)) {
            if (props.suppressaction.some(e => e.type === tabvalue && e.action === "UPDATE")) showupdate = false;
            if (props.suppressaction.some(e => e.type === tabvalue && e.action === "INSERT")) showinsert = false;
            if (props.suppressaction.some(e => e.type === tabvalue && e.action === "NEW FORM")) shownew = false;
            if (props.suppressaction.some(e => e.type === tabvalue && e.action === "ENTRY FORM")) showentry = false;
        }
        if (isEnabled(readonly)) {
            showupdate = false;
            showinsert = false;
        }

        let options = [];
        if (showupdate) options.push("UPDATE");
        if (showinsert) options.push("INSERT");
        if (props.entryform) {
            if (!isEnabled(readonly)) {
                if (!IsStatusSuppress("NEW FORM") && shownew) options.push("NEW FORM");
            }
            if (!IsStatusSuppress("ENTRY FORM") && showentry) options.push("ENTRY FORM");
        }
        if (props.masonry && tabvalue === "0" && !IsStatusSuppress("MASONRY")) {
            options.push("MASONRY");
        }
        return options.length === 1 && options[0] === "INSERT";
    }

    function setgridContext(data, status) {
        updateGridContext({
            status: isEmpty(status) ? formstatus : status,
            rowData: data.rowData,
            theme: formstyle
        });
    }
    function scheduleRedrawRows(api, params) {
        if (isEmpty(api) || typeof api.redrawRows !== "function") return;
        if (redrawRowsTimerRef.current !== null) {
            clearTimeout(redrawRowsTimerRef.current);
        }
        redrawRowsTimerRef.current = setTimeout(() => {
            redrawRowsTimerRef.current = null;
            api.redrawRows(params);
        }, 0);
    }

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);

    useEffect(() => {
        return () => {
            if (redrawRowsTimerRef.current !== null) {
                clearTimeout(redrawRowsTimerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (corpkey === '' || account === '') {
            //↓に入る事はない（ver3以降）
            let key = search.split("key=")[1];
            if (isEmpty(key)) {
                dispatch(resetstore());
                history.push('/')
                return;
            } else {
                let data = getcontinuekey(key);
                if (data === null) {
                    dispatch(resetstore());
                    history.push('/')
                    return;
                }
                //別タブからの起動。ログイン情報継続
                dispatch(continueinfo(data.user));
                dispatch(setmenus(data.menus));
                dispatch(resetform());
                dispatch(setmenuinfo(data.menuinfo));
                let newurl = appurl(data.menuinfo.controller, data.menuinfo.subkey);
                if (isEmpty(data.state)) {
                    history.replace('/' + newurl);
                } else {
                    //DataTreeから起動
                    if (newurl.indexOf('?') === -1) {
                        history.replace({ pathname: "/" + newurl, state: data.state });
                    } else {
                        history.replace({ pathname: "/" + newurl.split('?')[0], search: '?' + newurl.split('?')[1], state: data.state });
                    }
                }
                return;
            }
        }

        let key = prestoragenamekey();
        let prename = getcookie(key);
        if (prename !== "") dispatch(setprestorage(prename));    //前回開いた保存名セット
        if (gridApi === null) {
            fnc.current.wait(true);
        }

    }, [dispatch]);

    function appurl(controller, subkey) {
        if (isEmpty(subkey)) {
            return controller;
        }
        if (controller.indexOf("?") !== -1) {
            return controller + "&subkey=" + subkey;
        } else {
            return controller + "?subkey=" + subkey;
        }
    }

    useEffect(() => {
        let item = menus.find(e => e.controller.replace("?type=", ":") === props.controller && e.subkey === props.subkey);
        if (!isEmpty(item)) dispatch(setchangeurl(item.changeurl));
    }, menus);


    useEffect(() => {
        if (!isEmpty(menuinfo)) {
            settitle(menuinfo.name);
            setcategory(menuinfo.category);
            document.title = "KKAP Lite  #" + menuinfo.name;
        }
        if (isEmpty(props.navmenu)) return;
        var newmenu = DeepCopy(props.navmenu);
        if (!isEmpty(menuinfo)) {
            if (!isEmpty(menuinfo.ctrls)) {
                //リストレイアウトロック制御
                setlistlock(menuinfo.ctrls.indexOf("LOCK1") !== -1)
            }

            newmenu = props.navmenu.filter(function (nav) {
                if (nav.status === "VIEW") {
                    if (isEmpty(menuinfo.remove1)) return true;
                    return menuinfo.remove1.indexOf(nav.menuid) === -1;
                } else {
                    if (isEmpty(menuinfo.remove2)) return true;
                    return menuinfo.remove2.indexOf(nav.menuid) === -1;
                }
            });

        }
        setnavmenu(newmenu);
    }, [menuinfo]);

    //ListOptionの設定
    useEffect(() => {
        setisoption(false);
        setajustH(100);
        if (!isEmpty(listoption) && listoption.length > 0) {
            setoptpanel({ type: listoption[0].type });
            let changed = false;
            let newdata = listoptionRef.current === null ? {} : { ...listoptionRef.current };
            listoption.forEach(option => {
                if (isEmpty(option.initvalue)) return;
                if (newdata[option.columnid] === option.initvalue) return;
                newdata[option.columnid] = option.initvalue;
                changed = true;
            });
            listoptionRef.current = newdata;
            if (changed && !isEmpty(fnc.current)) fnc.current.entryrerender();
            setisoption(true);
            setajustH(130);
        }
    }, [listoption]);

    useEffect(() => {
        if (gridApi === null) return;
        if (isEnabled(props.insertonly) && formstatus === "VIEW") {
            dispatch(changestatus("INSERT"));
        }
    }, [gridApi]);

    useEffect(() => {
        if (gridApi === null) return;
        if (historyRef.current) return;     //他画面から遷移
        if (initialConditionStatusRef.current) return;
        initialConditionStatusRef.current = true;
        if (isEnabled(props.usecondition) && !isEnabled(props.entryonly) && !isEnabled(props.insertonly)) {
            setConditionCancelEnabled(false);
            dispatch(changestatus("CONDITION"));
        }
    }, [gridApi, dispatch, props.entryonly, props.insertonly, props.usecondition]);

    useEffect(() => {
        if (gridApi === null) return;
        setglobaldata(tagkey, searchtaglist);
        gridApi.onFilterChanged();
    }, [searchtaglist]);

    useEffect(() => {
        if (gridApi !== null) {
            gridApi.stopEditing();
            //    if(formstatus.indexOf("FORM") === -1 && columns.length > 1) {
            //        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
            //    }
        }
        if (isEnabled(props.insertonly) && formstatus !== "INSERT") {
            dispatch(changestatus("INSERT"));
            updateGridContext({
                status: "INSERT"
            });
            return;
        }
        updateGridContext({
            status: formstatus
        });
    }, [formstatus]);

    useEffect(() => {
        setagtheme(formstyle.header);
        setbodytheme(formstyle.body);
        updateGridContext({
            theme: formstyle
        });
    }, [formstyle]);

    useEffect(() => {
        if (!isEmpty(gridApi)) {
            gridApi.refreshHeader();   //Re Render
        }
    }, [agtheme]);

    useEffect(() => {
        if (gridApi === null) return;
        gridApi.setGridOption("context", gridContext);
        scheduleRedrawRows(gridApi);   //Re Render
    }, [gridApi, gridContext]);

    useEffect(() => {
        if (gridApi === null) return;
        //if (edittool === 0) return;
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
        const ranges = gridApi.getCellRanges();
        if (isEmpty(ranges)) return;
        if (ranges.length === 0) return;
        if (ranges[0].columns.length === 1 && ranges[0].startRow === ranges[0].endRow) {
            return;
        }
        //選択範囲がクリアされる対策
        //0.1s待機
        Interval(1, function (param) {
            const range = {
                rowStartIndex: param.startRow.rowIndex,
                rowEndIndex: param.endRow.rowIndex,
                columns: param.columns
            }
            gridApi.addCellRange(range);
        }, ranges[0])
    }, [edittool]);

    useEffect(() => {
        if (!isEnabled(props.insertonly)) return;
        if (!pendingInsertOnlyClearRef.current) return;
        if (gridApi === null) return;
        ApplyPendingInsertOnlyClear(gridApi);
    }, [listtabs, gridApi]);

    useEffect(() => {
        if (!showinit) return;
        //テーマ取得
        let tkey = storageKey(corpkey, account, "theme_" + formid);
        if (storageExistsKey(tkey)) {
            let theme = Getstorage(tkey);
            dispatch(themestyle(theme));
        } else {
            tkey = storageKey(corpkey, account, "theme_ALL");
            if (storageExistsKey(tkey)) {
                let theme = Getstorage(tkey);
                dispatch(themestyle(theme));
            }
        }
        setshowinit(false);
    }, [showinit]);

    useEffect(() => {
        if (!isEmpty(menus)) {
            let item = menus.find(e => e.controller.replace("?type=", ":") === props.controller && e.subkey === props.subkey);
            if (!isEmpty(item)) {
                if (item.name !== menuinfo.name) {
                    //ブラウザバックの場合メニュ情報セット
                    dispatch(clearform(true));
                    dispatch(setmenuinfo(item));
                }
            }
        }
        setshowinit(true);  //テーマ切り替え

        let key = search.split("key=")[1];
        if (!isEmpty(key)) {    //別タブ起動
            let calldata = Loadstorage(key);
            if (!isEmpty(calldata.state)) { //他画面からの連携起動
                if (isEmpty(calldata.menuinfo)) {
                    //menu未登録画面 暫定エラー回避
                    history.replace({state: calldata.state });
                } else {
                    let newurl = appurl(calldata.menuinfo.controller, calldata.menuinfo.subkey);
                    if (newurl.indexOf('?') === -1) {
                        history.replace({ pathname: "/" + newurl, state: calldata.state });
                    } else {
                        history.replace({ pathname: "/" + newurl.split('?')[0], search: '?' + newurl.split('?')[1], state: calldata.state });
                    }
                }
                historyRef.current = true;
                if (!customTarget(corpkey, 'tsi')) {
                    dispatch(changestatus(isEmpty(calldata.state.code) ? "NEW FORM" : "ENTRY FORM"));
                }
                return;
            }
        }

        if (isEnabled(props.entryonly)) {   //Entryのみ
            dispatch(setctrl("DEL2"));  //削除を除外
            dispatch(changestatus("ENTRY FORM"));
            EntryCall();
            return;
        }

        //ListTab/ListOption取得
        setListInfoLoaded(false);
        listoptionRef.current = null;
        ListInfoGet();

        listtypeRef.current = -1;
        if (gridApi === null) return;
        fnc.current.initMaster([]);
        setsearchword('');
        setsearchtaglist([]);
        gridApi.setGridOption("quickFilterText", "");
        gridApi.setGridOption("rowData", []);
        setmenuopen(false);
        if (tabvalue !== "0") {
            dispatch(gridtabvalue("")); //gridtab select
            settabvalue("0");
        }
        setglobaldata(tagkey, searchtaglist);
        popstateRef.current = false;

    }, [search]);

    useEffect(() => {
        if (isEmpty(selectrowid)) return;
        if (selectopen && selectrowid.length > 1) {
            //検索リスト起動時行選択状態を復元
            for (let i = 0; i < selectrowid.length; i++) {
                let node = gridApi.getRowNode(selectrowid[i]);
                if (!isEmpty(node)) node.setSelected(true);
            }
        }
    }, [selectopen, selectrowid]);

    useEffect(() => {
        if (gridApi === null) return;
        var newtype = GetListType();
        if (isEmpty(newtype)) return;
        if (listtype !== newtype) {
            AGRef.current.SaveColState(storagekey(listtype));   //元の状態を保持
            setlisttype(newtype);
            if (!isEmpty(props.tabvalueChange)) {
                props.tabvalueChange(newtype)
            }
        }
    }, [tabvalue, isoption, listoption, listtabs]);

    useEffect(() => {
        if (!listInfoLoaded) return;
        if (historyRef.current) return;
        if (gridApi === null) return;
        //if (!isEmpty(listoption) && listoption.length > 0 && !isoption) return;
        const resolvedListType = GetListType();
        if (isEmpty(resolvedListType)) return;
        if (listtype !== resolvedListType) return;
        const currentListType = isEmpty(listtype) ? GetListType() : listtype;
        if (currentListType === listtypeRef.current) return;
        if (isEnabled(props.usecondition)) {
            dispatch(clearform2(true));
        } else {
            dispatch(clearform(true));
        }
        setfileimp(false);
        AGRef.current.GridClear(0);
        GetList(true);
    }, [listInfoLoaded, listtype, tabvalue, isoption, listoption, listtabs, gridApi]);

    useEffect(() => {
        if (isEmpty(columninfo)) return;
        setcondition(columninfo.some(e => e.keyindex !== 0));
    }, [columninfo]);

    useEffect(() => {
        if (!isEnabled(props.list)) return;
        if (!condition) return;
        if (isEmpty(searchitems)) return;
        if (searchitems.length === 0) return;
        OpenSearchpanel();
    }, [searchitems]);

    //Tab変更
    function tabChange(newValue, oldvalue) {
        if (newValue === oldvalue) return;
        settabvalue(newValue);
    }
    //ListOption変更
    function OptionChanged(colid, newvalue) {
        if (props.OptionChanged) props.OptionChanged(colid, newvalue);
        if (isEmpty(listoption)) return;
        var col = listoption.find(e => e.columnid === colid);
        if (isEmpty(col)) return;
        if (col.headerfix !== 1) return;

        //レイアウト変更用項目の場合listtypeを変更
        var newtype = GetListType();
        if (listtype !== newtype) {
            AGRef.current.SaveColState(storagekey(listtype));   //元の状態を保持
        }
        setlisttype(newtype);
    }
    //listtype取得
    function GetListType() {
        var newtype = NumConv(tabvalue);
        try {
            if (isoption) {
                var col = listoption.find(e => e.headerfix === 1);  //レイアウト読み込み必要
                if (isEmpty(col)) return newtype.toString();
                //listtype=選択Listoption×ListTabの数＋選択Tab
                if (listoptionRef.current === null) return "";
                const optionValue = DicVal(listoptionRef.current, col.columnid, '0').toString();
                if (!props.tabs) {
                    newtype = NumConv(optionValue);
                } else {
                    if (optionValue !== '0') {
                        var tabcont = listtabs.length === 0 ? 1 : listtabs.length;
                        newtype = NumConv(optionValue) * tabcont + NumConv(tabvalue);
                    }
                }
            }
        } catch (e) {
            var a = e;
        }
        return newtype.toString();
    }

    //agGrid event
    function onGridReady(params) {
        if (gridApi !== null) return;
        setGridApi(params.api);
        setGridColumnApi(params.api);
        setRowHeight(AGRef.current.GetRowHeight(storagekey(), null));
        setlisttype('0');
        setglobaldata(tagkey, searchtaglist);
    }
    //Entry呼び出し
    function EntryCall(data, pushcode) {
        if (isEmpty(props.show)) return;
        var option = null;
        if (isoption) {
            //    option = props.entrydataRef.current[listoption[0].columnid];
            option = listoptionRef.current[listoption[0].columnid];
        }
        return props.show(data, pushcode, option);
    }
    //メニューコマンド
    function MenuClick(menu) {
        gridApi.stopEditing();
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
        if (menu === 'clear') {
            if (formstatus === "INSERT") {
                ClearSheet();
            } else {
                props.entrycallback(menu); return;
            }
            return;
        }
        if (menu === 'reload') {
            if (isViewStatus) {
                fnc.current.wait(true);
                GetList(false);
            } else {
                EntryCall();
            }
            return;
        }
        if (menu === 'save') {
            clearwarning();
            if (formstatus === 'INSERT') {
                let rowdata = AGRef.current.GetAfterFilterData();
                if (rowdata.length === 0) {
                    fnc.current.warnmsg("登録データが存在しません");
                    return;
                }
                if (!isEnabled(props.slipsave)) {
                    if (!AGRef.current.isshownPrimary(columninfo)) {
                        fnc.current.warnmsg("キーがレイアウトに含まれていません");
                        return;
                    }
                }
                //必須項目が非表示かチェック
                let err = [];
                if (AGRef.current.unshownRequired(columninfo, tabvalue, err, isEnabled(props.slipsave))) {
                    fnc.current.warnmsg("必須項目が含まれていません。「" + err[0] + "」を追加してください");
                    return;
                }
                if (!isEmpty(props.queryaction)) {
                    //登録前処理
                    if (!props.queryaction(menu, { tabvalue: tabvalue })) return;
                }
                const param = {
                    "type": GetListType(),
                    "rowdata": rowdata,
                    "coldef": AGRef.current.GetshownColDef(),
                    "colinfo": columninfo,
                    "controller": props.controller,
                    "tabletype": tabvalue
                }
                let msg = ["入力されたデータを新規登録します。よろしいですか？",
                    "※フィルタリングによる非表示行は登録対象となりません。"];
                fnc.current.confmsg(msg, () => Insert(param));
            }
            if (formstatus === 'UPDATE') {
                let rowdata = null;
                if (fileimp) {  //ファイル取込
                    rowdata = AGRef.current.GetAfterFilterData();
                    if (rowdata.length === 0) {
                        fnc.current.warnmsg("更新データは存在しません");
                        return;
                    }
                } else {
                    rowdata = AGRef.current.GetModifyRows(storekey);
                    if (rowdata.length === 0) {
                        fnc.current.warnmsg("編集されたデータは存在しません");
                        return;
                    }
                }
                const param = {
                    "type": GetListType(),
                    "rowdata": rowdata,
                    "coldef": AGRef.current.GetshownColDef(),
                    "colinfo": columninfo,
                    "controller": props.controller,
                    "tabletype": tabvalue,
                    "formstatus": formstatus
                }
                let msg = ["編集されたデータの更新を行います。よろしいですか？",
                    "※非表示項目、フィルタリングによる非表示行は更新対象となりません。"];
                if (fileimp)
                    msg = ["インポートされたデータの更新を行います。よろしいですか？",
                        "※非表示項目、フィルタリングによる非表示行は更新対象となりません。"];
                fnc.current.confmsg(msg, () => Update(param));
            }
            if (formstatus === 'VIEW') {
                let rowdata = AGRef.current.GetModifyRows(storekey);
                if (rowdata.length === 0) {
                    fnc.current.warnmsg("編集されたデータは存在しません");
                    return;
                }
                const param = {
                    "rowdata": rowdata,
                    "coldef": AGRef.current.GetshownColDef(),
                    "colinfo": columninfo,
                    "controller": props.controller,
                    "tabletype": tabvalue,
                    "formstatus": formstatus
                }
                let msg = ["編集されたMy項目の更新を行います。よろしいですか？",
                    "※非表示項目、フィルタリングによる非表示行は登録対象となりません。"];
                fnc.current.confmsg(msg, () => Update(param));
            }
            if (Operation(formstatus) === OP.ENTRY) {
                if (entrylock) {
                    fnc.current.warnmsg("データがロックされているか権限がないため登録できません");
                    return;
                }
                props.entrycallback(menu, entrysavefinally, GetList); return;
            }
            return;
        }
        if (menu === 'delete') {
            clearwarning();
            if (!isEmpty(props.queryaction)) {
                //削除前処理
                if (!props.queryaction(menu, { tabvalue: tabvalue })) return;
            }
            if (Operation(formstatus) === OP.ENTRY) {
                if (entrylock) {
                    fnc.current.warnmsg("データがロックされているか権限がないため削除できません");
                    return;
                }
                fnc.current.confmsg("データの削除を行います。データの復帰はできませんよろしいですか？", () => props.entrycallback(menu, entrydeletefinally));
                return;
            }
            let rowdata = AGRef.current.GetSelectrowdata();
            if (rowdata.length === 0) {
                fnc.current.warnmsg("削除するデータを選択してください");
                return;
            }
            fnc.current.confmsg("選択された" + rowdata.length + "行のデータ削除を行います。データの復帰はできませんよろしいですか？", () => Delete(rowdata));
            return;
        }
        if (menu === 'saveas') {
            let rowdata = AGRef.current.GetSelectrowdata();
            if (rowdata.length === 0) {
                fnc.current.warnmsg("保存するデータを選択してください");
                return;
            }
            fnc.current.formdialogopen({
                title: "名前を付けて保存", inputname: "保存名", dialogtype: 1,
                placeholder: "保存名を入力してください",
                defaultvalue: storagename,
                contents: "選択データのキー情報及びMy項目を保存します。",
                contents2: "※非表示のMy項目は登録対象となりません。", onApply: (e) => SaveAs(e, rowdata)
            });
            function SaveAs(e, rowdata) {
                if (storagename === e.key) {
                    if (!storageupdate) {
                        fnc.current.warnmsg("この保存名に対する書き込み権限がありません");
                        return;
                    } else {
                        fnc.current.confmsg("保存データを上書きします。よろしいですか？", () => Apply(e, rowdata));
                    }
                } else {
                    Apply(e, rowdata);
                }
            }
            function Apply(e, rowdata) {
                const p = {
                    "controller": props.controller,
                    "rowdata": rowdata,
                    "coldef": AGRef.current.GetshownColDef(),
                    "colinfo": columninfo,
                    "update": storagename === e.key
                }
                const param = Object.assign({}, p, e);
                fnc.current.postaxios(props.actionurl.saveas, param,
                    {
                        onSuccess: function (data) {
                            fnc.current.formdialogclose();
                            fnc.current.modify(false);
                            fnc.current.success();
                            fnc.current.wait(false);
                        },
                        errmsg: "保存に失敗しました"
                    }
                )
            }
            return;
        }
        if (menu === 'stropen') {
            //検索リストOPEN
            const datainfo = { datatype: CELLTYPE.MASTER, dataid: "p_storage", primary: false, keyinfo: props.controller, columnid: "Storage" }
            fnc.current.searchlistopen({
                label: "保存データ",
                multiple: false,
                rowmode: false,
                data: datainfo,
                doApply: OpenStorage,
            });
            function OpenStorage(e) {
                if (modify) {
                    fnc.current.confmsg("編集中のデータは破棄されます。実行してよろしいですか？", () => OpenStorageApply(e.value));
                } else {
                    OpenStorageApply(e.value);
                }
            }
            return;
        }
        if (menu === 'stropen2') {
            //前回使用保存データを開く
            if (modify) {
                fnc.current.confmsg("編集中のデータは破棄されます。実行してよろしいですか？", () => Apply());
            } else {
                Apply();
            }
            function Apply() {
                let name = prestoragename;
                dispatch(setprestorage(""));    //前回名一旦クリア
                let key = prestoragenamekey();
                setcookie(key, "");
                OpenStorageApply(name);
            }
            return;
        }
        if (menu === 'excel') {
            var excelparam = {
                fileName: props.controller + ".xlsx",
                processCellCallback: ExcelCallback,
                processRowGroupCallback: rowGroupCallback,
            }
            gridApi.exportDataAsExcel(excelparam);
            return;
        }
        if (menu === 'import') {
            clearwarning();
            if (!AGRef.current.isshownPrimary(columninfo)) {
                if (formstatus === 'UPDATE') {
                    fnc.current.warnmsg("キーがレイアウトに含まれていません");
                } else {
                    fnc.current.confmsg("キーがレイアウトに含まれていません。処理を継続しますか？", () => uploadRef.current.click());
                }
            } else {
                uploadRef.current.click();
            }
            return;
        }
        if (menu === 'upload') {
            clearwarning();
            let rowdata = AGRef.current.GetSelectrowdata();
            if (rowdata.length === 0) {
                fnc.current.warnmsg("アップロードするデータを選択してください");
                return;
            }
            if (rowdata.length !== 1) {
                fnc.current.warnmsg("複数行選択されてます");
                return;
            }
            if (DicVal(rowdata[0], "locked", false)) {
                fnc.current.warnmsg("データがロックされているか権限がないため処理できません");
                return;
            }
            upload2Ref.current.click();
            return;
        }
        if (menu === 'upload2') {
            clearwarning();
            let rowdata = AGRef.current.GetSelectrowdata();
            if (rowdata.length === 0) {
                fnc.current.warnmsg("アップロードするデータを選択してください");
                return;
            }
            for (let i = 0; i < rowdata.length; i++) {
                if (DicVal(rowdata[i], "locked", false)) {
                    fnc.current.warnmsg("データがロックされているデータが選択されているまたは権限がないため処理できません");
                    return;
                }
            }
            let data = {
                dataid: "m_image",
                datatype: CELLTYPE.TEXT
            };
            fnc.current.searchlistopen({
                label: "画像/資料マスタ",
                multiple: true,
                rowmode: false,
                data: data,
                doApply: addimage
            });
            return;
        }
        if (menu === 'formupload') {
            if (entrylock) {
                fnc.current.warnmsg("データがロックされているか権限がないため処理できません");
                return;
            }
            upload2Ref.current.click();
            return;
        }
        if (menu === 'formupload2') {
            if (entrylock) {
                fnc.current.warnmsg("データがロックされているか権限がないため処理できません");
                return;
            }
            let data = {
                dataid: "m_image",
                datatype: CELLTYPE.TEXT
            };
            fnc.current.searchlistopen({
                label: "画像/資料マスタ",
                multiple: true,
                rowmode: false,
                data: data,
                doApply: addimage
            });
            return;
        }
        function addimage(e) {
            let rowdata = AGRef.current.GetSelectrowdata();
            if (Operation(formstatus) === OP.ENTRY) {
                rowdata = entryrow;
            }
            let key = "";
            for (let i = 0; i < props.primarykey.length; i++) {
                if (rowdata[0][props.primarykey[i]]) {
                    key = props.primarykey[i];
                    break;
                }
            }
            if (key === "") {
                fnc.current.warnmsg("キーが見つかりませんでした");
                return;
            }
            let code = "";
            for (let i = 0; i < rowdata.length; i++) {
                if (code.length !== 0) code += ",";
                code += rowdata[i][key];
            }
            if (Operation(formstatus) !== OP.ENTRY && rowdata.length > 1) {
                let msg = ["選択された" + rowdata.length + "件のデータにマスタデータを追加します。同一ファイルが存在した場合はマスタファイルに更新されます。よろしいですか？"];
                fnc.current.confmsg(msg, () => execute(false));
            } else {
                execute(true);
            }
            function execute(check) {
                const p = {
                    controller: props.controller,
                    code: code,
                    request: e.value,
                    "check": check
                }
                fnc.current.postaxios(props.actionurl.imageadd, p,
                    {
                        onSuccess: function (data) {
                            fnc.current.success();
                            if (Operation(formstatus) === OP.ENTRY) {
                                if (!isEmpty(props.uploaded)) props.uploaded(data);
                            }
                            fnc.current.wait(false);
                        },
                        onError: function (data) {
                            fnc.current.wait(false);
                            if (data.request === "") {
                                fnc.warnmessage("ファイルの追加に失敗しました");
                                return;
                            }
                            let msg = ["同一ファイルが存在します。上書きされますがよろしいですか？", "対象ファイル:" + data.request];
                            p.check = false;
                            fnc.current.confmsg(msg, () => imageupdate(p));
                        }
                    });
                fnc.current.searchlistclose();
            }
        }
        function imageupdate(param) {
            fnc.current.postaxios(props.actionurl.imageadd, param,
                {
                    onSuccess: function (data) {
                        if (Operation(formstatus) === OP.ENTRY) {
                            if (!isEmpty(props.uploaded)) props.uploaded(data);
                        }
                        fnc.current.success();
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                });
        }
        if (menu === "listdatatree") {
            const selectedRows = gridApi.getSelectedRows();
            if (!selectedRows || selectedRows.length === 0) {
                fnc.current.warnmsg("行を選択してください");
                return;
            }
            if (selectedRows.length !== 1) {
                fnc.current.warnmsg("複数行選択されています");
                return;
            }
            props.entrycallback(menu, null, selectedRows);
            return;
        }
        if (isViewStatus) {
            if (reports.some(e => e.id === menu)) {   //帳票
                const selectedRows = gridApi.getSelectedRows();
                if (!selectedRows || selectedRows.length === 0) {
                    fnc.current.warnmsg("対象データを選択してください");
                    return;
                }
                props.entrycallback(menu, null, selectedRows);
                return;
            }
        }
        //if (Operation(formstatus) === OP.ENTRY)
        //    props.entrycallback(menu, entrysavefinally);
        if (!isEmpty(props.entrycallback))
            props.entrycallback(menu, entrysavefinally, GetList, gridApi);

        function entrydeletefinally(code, primarykeys) {
            var key = "";
            for (let i = 0; i < primarykeys.length; i++) {
                if (columninfo.some(e => e.columnid === primarykeys[i])) {
                    key = primarykeys[i]; break;
                }
            }
            if (key !== "") {
                let data = AGRef.current.GetStoreDataSource();
                let removes = data.filter(e => e[key] === code);
                let r = [];
                for (let i = 0; i < removes.length; i++) {
                    let node = gridApi.getRowNode(removes[i].rowid);
                    if (!isEmpty(node)) r.push(node.data);
                }
                if (r.length !== 0) gridApi.applyTransaction({ remove: r });
                let newdata = data.filter(e => e[key] !== code);  //削除データを除外
                AGRef.current.StoreDataSource(newdata, setgridContext, "VIEW");
            }
            ChangeStatus("ENTRY FORM", "VIEW", true);
        }
    }
    const ExcelCallback = (params) => {
        if (isEmpty(params.column.colDef.colinfo)) return params.value;
        if (params.node.group) {
            return params.value;
        }
        var colid = params.column.colId + "_nm";
        if (params.column.colDef.colinfo.datatype === CELLTYPE.MASTER) {
            if (colid in params.node.data)
                return params.value + " " + params.node.data[colid];
        }
        return params.value;
    };
    const rowGroupCallback = (params) => {
        var colid = params.node.field;
        var column = params.api.columnModel.columnDefs.find(e => e.field === colid);
        if (!isEmpty(column)) {
            if (column.datatype === CELLTYPE.MASTER) {
                let colnm = colid + "_nm";
                var data = params.context.rowData.find(e => e[colid] === params.node.key);
                if (colnm in data)
                    return params.node.key + " " + data[colnm] + " 計";
            }
        }
        return params.node.key + " 計";
    };

    //LIST実行
    function ListExecute() {
        if (!isEmpty(props.queryexecute)) {
            if (!props.queryexecute(listoptionRef.current)) return;
        }
        GetList(false, true);
    }
    function ReplaceListData(newlists, keys, data) {
        if (newlists.length === 0) return;
        var pkey = keys.find(key => key in newlists[0]);
        if (isEmpty(pkey)) return;
        var code = newlists[0][pkey];

        var index = data.findIndex(row => row[pkey] === code);
        if (index === -1) return;

        // 一致する行をすべて削除
        for (var i = data.length - 1; i >= 0; i--) {
            if (data[i][pkey] === code) {
                data.splice(i, 1);
            }
        }

        // 元の先頭位置に newlists を挿入
        data.splice(index, 0, ...newlists);

        AGRef.current.StoreDataSource(data, setgridContext);
        gridApi.setGridOption("rowData", data);
    }
    function entrysavefinally(newdata, newlists, keys) {
        if (isEmpty(newdata) && isEmpty(newlists)) return;
        let data = AGRef.current.GetStoreDataSource();
        if (formstatus === "ENTRY FORM" || formstatus === "MASONRY") {
            if (!isEmpty(newlists)) {
                ReplaceListData(newlists, keys, data);
                return;
            }
            if (tabvalue === "0") {
                let index = data.findIndex(e => e.rowid === newdata.rowid);
                if (index === -1) {     //add
                    data.push(newdata);
                } else {                //update
                    data[index] = newdata;
                }
                AGRef.current.StoreDataSource(data, setgridContext);
                if (index !== -1) {
                    let rowNode = gridApi.getRowNode(newdata["rowid"]);
                    if (!isEmpty(rowNode)) {
                        rowNode.setData(newdata);
                    }
                }
            }
            entrymodifyRef.current = true;
        } else {
            if (tabvalue === "0") {
                data.push(newdata);
                AGRef.current.StoreDataSource(data, setgridContext, formstatus);
            }
            //    ChangeStatus(formstatus, "VIEW", true);
        }
    }
    //保存データを開く
    function OpenStorageApply(value) {
        const param = { code: value, controller: props.controller, colinfo: columninfo, type: tabvalue };
        fnc.current.postaxios('common/OpenStorage', param,
            {
                onSuccess: function (data) {
                    fnc.current.searchlistclose();
                    storageRef.current = data;
                    if (storagename.length === 0) {
                        let sticky = {
                            headerName: "§付箋",
                            field: "sticky",
                            colId: "sticky",
                            hide: false,
                            editable: data.write === "1",
                            datatype: CELLTYPE.STICKY,
                        }
                        let col = columninfo.find(e => e.datatype === CELLTYPE.STICKY);
                        if (!isEmpty(col)) {
                            sticky.colinfo = DeepCopy(col);
                            sticky.colinfo.columnid = "sticky";
                        } else {
                            let colinfo = DeepCopy(columninfo[0]);
                            colinfo.columnid = "sticky";
                            colinfo.datatype = CELLTYPE.STICKY;
                            sticky.colinfo = colinfo;
                        }
                        AGRef.current.SetColDefTypeInfo("storagesticky", sticky);
                        let newcol = [...[sticky], ...columns];
                        setcolumns(newcol);
                    } else {
                        let newcolumns = columns;
                        let coldef = columns.find(e => e.field === "sticky");
                        if (!isEmpty(coldef)) coldef.editable = data.write === "1";
                        //coldef = newcolumns.find(e => e.field === "memo");
                        //if (!isEmpty(coldef)) coldef.editable = data.write === "1";
                        setcolumns(newcolumns);
                    }
                    gridApi.setGridOption("rowData", data.rowdata);
                    //初期データ保持
                    AGRef.current.StoreDataSource(data.rowdata, setgridContext, "VIEW");
                    dispatch(setstoragename({ storagename: value, storageupdate: data.write === "1" }));
                    let key = prestoragenamekey();
                    setcookie(key, value);
                    fnc.current.modify(false);
                    fnc.current.wait(false);
                },
                errmsg: "読み込みに失敗しました"
            }
        )
    }
    //新規登録処理
    function Insert(param) {
        fnc.current.postaxios(props.actionurl.insert, param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        setdbupdate(true);
                        ClearSheet();
                        fnc.current.success();
                    }
                    else {
                        let msg = data.request + "件のデータが登録できませんでした。";
                        if (!isEmpty(data.errcode)) msg = data.errcode;
                        fnc.current.showwarndescription(msg, data.warning);

                        if (isEmpty(data.errcode)) {
                            //登録データ行削除
                            let removedata = [];
                            gridApi.forEachNode(function (node) {
                                let result = data.warning.find(e => e.rowid === node.data.rowid);
                                if (isEmpty(result))
                                    removedata.push(node.data);
                            });
                            if (removedata.length !== 0) {
                                gridApi.applyTransaction({ remove: removedata });
                                setdbupdate(true);
                            }
                            scheduleRedrawRows(gridApi);   //Re Render
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    //更新処理
    function Update(param) {
        fnc.current.postaxios(props.actionurl.update, param,
            {
                onSuccess: function (data) {
                    //更新できた行データを反映
                    if (data.warning.length === 0) {
                        AGRef.current.UpdateModifyRows(data.warning, setgridContext);
                        fnc.current.modify(false);
                        setdbupdate(true);
                        fnc.current.success();
                    }
                    else {
                        let msg = data.request + "件のデータが更新できませんでした。";
                        if (!isEmpty(data.errcode)) msg = data.errcode;
                        fnc.current.showwarndescription(msg, data.warning);
                        if (isEmpty(data.errcode)) {
                            AGRef.current.UpdateModifyRows(data.warning, setgridContext);
                        }
                    }
                    // gridApi.redrawRows();   //Re Render
                    fnc.current.wait(false);
                },
                errmsg: "更新に失敗しました"
            }
        )
    }
    //削除処理
    function Delete(rowdata) {
        const param = {
            "type": GetListType(),
            "controller": props.controller,
            "rowdata": rowdata,
            "colinfo": columninfo,
            "tabletype": tabvalue
        }
        fnc.current.postaxios(props.actionurl.delete, param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        //選択データ削除
                        const selectedRows = gridApi.getSelectedRows();
                        gridApi.applyTransaction({ remove: selectedRows });
                        setdbupdate(true);
                        fnc.current.success();
                    }
                    else {
                        let msg = data.request + "件のデータが削除できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                        //削除された行を削除
                        let removedata = [];
                        const selectedRows = gridApi.getSelectedRows();
                        selectedRows.forEach(function (rows) {
                            let result = data.warning.find(e => e.rowid === rows.rowid);
                            if (isEmpty(result))
                                removedata.push(rows);
                        });
                        if (removedata.length !== 0) {
                            gridApi.applyTransaction({ remove: removedata });
                            setdbupdate(true);
                        }
                        scheduleRedrawRows(gridApi);   //Re Render
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    //エラー項目リンク
    function LinkField(description) {
        if (Operation(formstatus) === OP.ENTRY) {
            props.entrycallback("linkfield", { table: description.table, field: description.col, rowid: description.rowid, type: description.type });
        } else {
            AGRef.current.SetRowSelect(description.rowid, description.col);
        }
    }
    //ワーニングクリア
    function clearwarning() {
        fnc.current.closewarnning();
        scheduleRedrawRows(gridApi);   //Re Render
    }

    //ファイルUpload
    const onFileUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let len = 0;
        let files = [];
        for (let i = 0; i < event.target.files.length; i++) {
            len += event.target.files[i].size;
            files.push(event.target.files[i]);
        }
        event.target.value = "";
        if (files.length > 10) {
            fnc.current.warnmsg("１度にアップロードできるのは１０ファイルまでです。");
            return;
        }
        if (len > 10000000) {
            fnc.current.warnmsg("選択ファイルはアップロード可能なファイルサイズを超えています。");
            return;
        }
        if (isEmpty(props.primarykey)) {
            fnc.current.warnmsg("キー定義が必要です");
            return;
        }

        let rowdata = AGRef.current.GetSelectrowdata();
        if (Operation(formstatus) === OP.ENTRY) {
            rowdata = entryrow;
        }
        let code = "";
        for (let i = 0; i < props.primarykey.length; i++) {
            if (rowdata[0][props.primarykey[i]]) {
                code = rowdata[0][props.primarykey[i]];
                break;
            }
        }
        if (code === "") {
            fnc.current.warnmsg("キーが見つかりませんでした");
            return;
        }
        let param = {
            "code": code,
            "count": files.length,
            "check": true
        };
        for (let i = 0; i < files.length; i++) {
            param["file" + (i + 1).toString()] = files[i];
        }

        fnc.current.fileupload(props.actionurl.upload, param,
            {
                onSuccess: function (data) {
                    if (!isEmpty(props.uploaded)) {
                        props.uploaded(data);
                    }
                    fnc.current.success();
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    if (data.request === "") {
                        fnc.warnmessage(data.errDescription);
                        return;
                    }
                    let msg = ["アップロード済のファイルが存在します。上書きされますがよろしいですか？",
                        "対象ファイル:" + data.request];
                    param.check = false;
                    fnc.current.confmsg(msg, () => fileupload(param));
                }
            });
    };
    function fileupload(param) {
        fnc.current.fileupload(props.actionurl.upload, param,
            {
                onSuccess: function (data) {
                    if (!isEmpty(props.uploaded)) props.uploaded(data);
                    fnc.current.success();
                    fnc.current.wait(false);
                },
                errmsg: "アップロードに失敗しました"
            });
    }
    //ファイル取込
    const onFileInputChange = (event) => {
        const file = event.target.files[0];
        event.target.value = "";
        if (!validFileType(file)) {
            fnc.current.warnmsg("ファイル形式が無効です。Excelファイルを指定してください。");
            return;
        }
        if (file.size > 10000000) {
            fnc.current.warnmsg("選択ファイルはアップロード可能なファイルサイズを超えています。");
            return;
        }
        //    let msg = ["シートに「" + file.name + "」の内容を取り込みます。",
        //        "表示中の内容は破棄されます。よろしいですか？",
        //        "UPDATEの場合重複するデータ行の取り込みは行われません。",
        //        "レイアウトと取り込みファイル形式は一致している必要があります"
        //    ];
        //    fnc.current.confmsg(msg, () => SheetImport(file));
        fnc.current.formdialogopen(
            {
                title: "Excelデータ取込", dialogtype: 9,
                customcontents: 4,
                checkboxlabel: "そのままの内容を取り込む（通常は前後スペース、タブ、改行は取り除かれます）,先頭行を取り込む（ヘッダ行がないExcelシートの取り込みの場合チェック）",
                contents: "シートに「" + file.name + "」の内容を取り込みます。表示中の内容は破棄されます。よろしいですか？",
                contents2: "レイアウトと取り込みファイル形式は一致している必要があります。",
                contents3: "UPDATEの場合重複するデータ行の取り込みは行われません。",
                onApply: (param) => SheetImport(file, param.check)
            });
    };
    function SheetImport(file, mode) {
        let column = AGRef.current.GetshownColDef();
        let keyidx = [];
        let masterfields = [];
        let showcolinfo = [];
        //主キーおよびマスタ参照フィールド抽出
        for (let i = 0; i < column.length; i++) {
            let col = columninfo.find(e => e.columnid === column[i].field);
            showcolinfo.push(col);
            if (col.datatype === CELLTYPE.MASTER) {
                var keyinfo = "";
                if (!isEmpty(col.keyinfo)) {
                    keyinfo = col.keyinfo.split("=")[0] + "=" + column.findIndex(e => e.field === col.keyinfo.split("=")[1]);
                }
                masterfields.push(i.toString() + "=" + col.dataid + ",keyinfo=" + keyinfo);
            }
            if (col.primary) keyidx.push(i);
        }
        fnc.current.formdialogclose();
        let param = {
            "file": file,
            "update": formstatus === 'UPDATE',
            "colcount": column.length,
            "keyidx": keyidx,
            "master": masterfields,
            "importmode": mode,
        }
        fnc.current.fileupload('excel/AGFileImport', param,
            {
                onSuccess: function (data) {
                    setfileimp(true);
                    if (data.master.length !== 0) {
                        fnc.current.margeMaster(data.master);
                    }
                    let csvdata = data.data;
                    let rows = csvTorowData(csvdata, showcolinfo);
                    gridApi.setGridOption('rowData', rows);
                    fnc.current.wait(false);
                    fnc.current.modify();
                },
                errmsg: "取り込みに失敗しました"
            }
        );
    }
    function csvTorowData(data, column ) {
        let list = [];
        let stickyfield = getglobaldata(stickykey);
        data.forEach(function (rowvalue) {
            let row = {};
            row["rowid"] = RandomKey();
            for (let c = 0; c < column.length; c++) {
                if (rowvalue.length < c) break;
                if (column[c].columnid === stickyfield) {
                    row[column[c].columnid] = { note: rowvalue[c] };
                } else {
                    if (column[c].datatype === CELLTYPE.MASTER || column[c].datatype === CELLTYPE.SELECT) {
                        row[column[c].columnid] = rowvalue[c].split(" ")[0];    //MASTER,SELECTで名称付きの場合コードのみを取得
                    } else {
                        row[column[c].columnid] = rowvalue[c];
                    }
                }
            }
            list.push(row);
        });

        return list;
    }
    function validFileType(file) {
        switch (file.type) {
            case "application/vnd.ms_excel":
                return true;
            //case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            //    return true;
            default:
                if (GetExtension(file.name) === "xlsx") {
                    return true;
                }
                //if (GetExtension(file.name) === "csv") {
                //    return true;
                //}
                break;
        }
        return false;
    }


    //検索実行
    function searchexecute(items) {
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
        //検索条件保存
        setglobaldata(condkey, items);
        if (formstatus !== 'VIEW' && formstatus !== 'CONDITION' && modify) {
            fnc.current.confmsg("編集中のデータは破棄されます。実行してよろしいですか？", () => ListExecute());
        } else {
            ListExecute();
        }
    }
    //保存データAction
    function storageaction(action) {
        if (action === "update") {  //付箋の更新
            let rowdata = AGRef.current.GetAfterFilterData();
            if (rowdata.length === 0) {
                fnc.current.warnmsg("登録データが存在しません");
                return;
            }
            fnc.current.confmsg("表示中の付箋を上書きします。よろしいですか？", () => Apply());
            function Apply() {
                const p = {
                    controller: props.controller,
                    key: storagename,
                    rowdata: rowdata,
                    coldef: AGRef.current.GetshownColDef(),
                    colinfo: columninfo,
                    update: true
                }
                fnc.current.postaxios(props.actionurl.saveas, p,
                    {
                        onSuccess: function (data) {
                            fnc.current.formdialogclose();
                            fnc.current.modify(false);
                            fnc.current.success();
                            fnc.current.wait(false);
                        },
                        errmsg: "保存に失敗しました"
                    }
                )
            }
        }
        if (action === "delete") {  //削除
            let rowdata = AGRef.current.GetSelectrowdata();
            if (rowdata.length === 0) {
                fnc.current.warnmsg("データを選択してください");
                return;
            }
            fnc.current.confmsg("保存データから選択行を除外します。よろしいですか？", () => Apply());
            function Apply() {
                const p = {
                    controller: props.controller,
                    key: storagename,
                    rowdata: rowdata,
                }
                fnc.current.postaxios(props.actionurl.storagerowdel, p,
                    {
                        onSuccess: function (data) {
                            fnc.current.formdialogclose();
                            gridApi.applyTransaction({ remove: rowdata });
                            fnc.current.success();
                            fnc.current.wait(false);
                        },
                        errmsg: "削除に失敗しました"
                    }
                )
            }
        }
        if (action === "share") {   //共有設定
            fnc.current.formdialogopen({
                title: "共有設定", dialogtype: 1, inputhide: true,
                contents: "作成者および管理者のみ設定の更新が可能です。",
                defaultvalue: storageRef.current,
                cmdlabel: "更新",
                onApply: (e) => Update(e)
            });
            function Update(e) {
                if (account !== storageRef.current.account && admin !== "1") {
                    fnc.current.warnmsg("権限がないため更新できません");
                    return;
                }
                fnc.current.confmsg("共有設定を更新します。よろしいですか？", () => Apply(e));
            }
            function Apply(e) {
                const param = e;
                param.controller = props.controller;
                param.key = storagename;
                fnc.current.postaxios("common/StorageUpdate", param,
                    {
                        onSuccess: function (data) {
                            storageRef.current = data;
                            fnc.current.formdialogclose();
                            fnc.current.success();
                            fnc.current.wait(false);
                        },
                        errmsg: "更新に失敗しました"
                    }
                )
            }
        }
    }
    //保存データを閉じる
    function storageclose() {
        if (modify) {
            fnc.current.confmsg("保存データを閉じます。編集中のデータは破棄されますがよろしいですか？", () => GetList());
        } else {
            GetList();
        }
    }

    //リスト取得 forcesearch=trueは条件指定実行
    async function GetList(initial, forcesearch) {
        const currentListType = isEmpty(listtype) ? GetListType() : listtype;
        const useConditionCall = isEnabled(props.usecondition);
        const conditionMode = useConditionCall && isEnabled(initial) && !isEnabled(forcesearch);
        //List後遷移ステータス
        var nextStatus = (isEnabled(props.insertonly) || isInsertOnly() ? "INSERT" : conditionMode ? "CONDITION" : "VIEW");

        if (isEnabled(props.entryonly)) return;     //Listなし
        // if (initial && historyRef.current) {
        //     //EntryFormが呼ばれた場合リスト表示しない
        //     historyRef.current = false;
        //     listtypeRef.current = -1
        //     return;
        // }
        historyRef.current = false;
        if (formstatus === "INSERT" && forcesearch) {
            dispatch(changestatus("VIEW"));
            listtypeRef.current = -1
        }
        if (initial && currentListType === listtypeRef.current) {
            return;     //再帰抑止
        }
        if (!initial && isEmpty(columninfo)) initial = true;
        try {
            listtypeRef.current = currentListType;
            setdbupdate(false);
            dispatch(setstoragename({ storagename: "", storageupdate: false }));
            scrollLeftRef.current = 0;
            var conditionitem = null;
            if (!isEnabled(initial) && condition) {  //検索条件あり
                //fnc.current.searchpanelclose();
                setsearchpanelopen(false);
                //検索条件読み込み
                conditionitem = getglobaldata(condkey);
            }
            if (!isEmpty(props.setcondition)) {
                props.setcondition(conditionitem);
            }
            let notshow = isEnabled(props.notshowndata) || isEnabled(props.insertonly);
            if (useConditionCall) {
                notshow = conditionMode;
            } else if (forcesearch) {
                notshow = false;   //検索実行時データ表示
            }
            if (isEmpty(props.actionurl.getlist)) {
                //Basic list
                let distinct = false;
                if (listtabs.length !== 0) {
                    distinct = listtabs.find(e => e.value === tabvalue).distinct;
                }
                fnc.current.postaxios(isEnabled(distinct) ? 'list/GetList' : 'common/GetListData',
                    {
                        controller: props.controller,
                        subkey: props.subkey,
                        type: currentListType.toString(),
                        initial: initial,
                        forcesearch: forcesearch,
                        items: conditionitem,
                        notshow: notshow,
                        showlimit: showlimit
                    },
                    {
                        onSuccess: function (data) {
                            if (initial) {
                                createColDef(data.colinfo, data.columns, data.prelayout, data.initlayout.trim().length === 0);
                                setcolumninfo(data.colinfo);
                                if (data.items !== null) setsearchitems(data.items);
                                if (isEmpty(gridApi)) {
                                    setRowData(data.rowdata);
                                } else {
                                    gridApi.setGridOption("rowData", data.rowdata);
                                }
                                setglobaldata(colfixkey, data.fitColumn);    //リアルタイム反映
                                dispatch(settoolpanel({
                                    layouts: data.layouts, prelayout: data.prelayout,
                                    initlayout: data.initlayout.trim().length === 0 ? " " : data.initlayout,
                                    showlimit: data.showlimit,
                                    fitColumn: data.fitColumn
                                }));
                                //mytagまたはmemoがある場合My項目登録メニュを有効にする ※子テーブルは無効
                                let myfield = false;
                                if (NumConv(tabvalue) === 0) {
                                    if (data.colinfo.some(e => e.columnid.indexOf("_mytag") !== -1 || e.columnid.indexOf("_memo") !== -1)) {
                                        myfield = true;
                                    }
                                }
                                setmysave(myfield);
                                if (isEnabled(props.insertonly)) {
                                    pendingInsertOnlyClearRef.current = true;
                                }
                            } else {
                                //保存データ項目消去
                                let coldef = columns.filter(function (item) {
                                    if (isEmpty(item.headerName)) return true;
                                    return item.headerName.indexOf("§") === -1;
                                });
                                if (coldef.length !== columns.length) {
                                    setcolumns(coldef);
                                }
                                gridApi.setGridOption("rowData", data.rowdata);
                            }
                            if (!isEmpty(data.note)) {
                                fnc.current.successmsg(data.note);
                            }
                            fnc.current.margeMaster(data.master);
                            //初期データ保持
                            AGRef.current.StoreDataSource(data.rowdata, setgridContext, nextStatus);
                            if (listtype !== currentListType) {
                                setlisttype(currentListType);
                            }
                            if (formstatus === "MASONRY") {
                                fnc.current.masonrydata(AGRef.current.GetAfterFilterData());
                            }
                            if (formstatus === "CONDITION" && nextStatus === "VIEW" && isoption) {
                                listoptionViewSnapshotRef.current = DeepCopy(listoptionRef.current)
                            }
                            if (nextStatus === "CONDITION") {
                                setConditionCancelEnabled(!notshow);
                                dispatch(changestatus("CONDITION"));
                            } else {
                                if (formstatus !== nextStatus) {
                                    dispatch(changestatus(nextStatus));
                                }
                            }
                            fnc.current.wait(false);
                        },
                    }
                )
            } else {
                //Custom list
                const param = {
                    controller: props.controller,
                    subkey: props.subkey,
                    type: currentListType.toString(),
                    coldef: AGRef.current.GetshownColDef(),
                    colinfo: columninfo,
                    items: conditionitem,
                    initial: initial,
                    forcesearch: forcesearch,
                    items: conditionitem,
                    notshow: notshow,
                    showlimit: showlimit
                }
                if (isoption) {
                    //    param["data"] = props.entrydataRef.current;
                    param["data"] = listoptionRef.current;
                }
                //表示前イベント
                if (!isEmpty(props.querygetlist)) {
                    props.querygetlist(param);
                    if(!param.notshow) nextStatus = "VIEW";
                }
                fnc.current.postaxios(props.actionurl.getlist, param,
                    {
                        onSuccess: function (data) {
                            if (initial) {
                                if (data.colinfo.filter(e => !isEmpty(e.groupcolumn)).length !== 0) {
                                    createColDef2(data.colinfo, data.columns, data.prelayout, data.initlayout.trim().length === 0);
                                } else {
                                    createColDef(data.colinfo, data.columns, data.prelayout, data.initlayout.trim().length === 0);
                                }
                                setcolumninfo(data.colinfo);
                                setsearchitems(data.items);
                                setglobaldata(colfixkey, data.fitColumn);   //リアルタイム反映
                                dispatch(settoolpanel({
                                    layouts: data.layouts, prelayout: data.prelayout,
                                    initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                                    showlimit: data.showlimit,
                                    fitColumn: data.fitColumn
                                }));
                                if (isEnabled(props.insertonly)) {
                                    pendingInsertOnlyClearRef.current = true;
                                }
                            }
                            setRowData(data.rowdata);
                            //合計行
                            if (DicVal(data.totaldata, 'length', 0) !== 0) {
                                gridApi.setGridOption('pinnedBottomRowData', [data.totaldata]);
                            }
                            if (!isEmpty(data.note)) {
                                fnc.current.successmsg(data.note);
                            }
                            fnc.current.margeMaster(data.master);
                            //データ保持
                            AGRef.current.StoreDataSource(data.rowdata, setgridContext, nextStatus);
                            if (listtype !== currentListType) {
                                setlisttype(currentListType);
                            }
                            if (formstatus === "CONDITION" && nextStatus === "VIEW" && isoption) {
                                listoptionViewSnapshotRef.current = DeepCopy(listoptionRef.current)
                            }
                            if (nextStatus === "CONDITION") {
                                setConditionCancelEnabled(!notshow);
                                dispatch(changestatus("CONDITION"));
                            } else {
                                if (formstatus !== nextStatus) {
                                    dispatch(changestatus(nextStatus));
                                }
                            }
                            fnc.current.wait(false);
                        },
                    }
                )
            }
        } catch (error) {
            fnc.current.wait(false);
            console.log(error);
        }
    }
    //ListTab/ListOption取得
    function ListInfoGet() {
        fnc.current.postaxios('common/GetListInfo', { "controller": props.controller, "subkey": props.subkey },
            {
                onSuccess: function (data) {
                    dispatch(setListTabs(data.tabs));
                    dispatch(setListOption(data.listoption));
                    setListInfoLoaded(true);
                    fnc.current.wait(false);
                }
            });
    }
    function createColDef(allcolumns, columns, prelayout, initlayout) {
        setglobaldata(stickykey, "");
        var all = allcolumns.filter(e => e.hidden !== "2")  //対象外項目を除く
        var colDef = [colDefsInit];     //RowNodeIdカラム
        var checkflg = false;
        if (prelayout || initlayout) {  //前回レイアウト or 既定レイアウト
            try {
                for (let i = 0; i < all.length; i++) {
                    let hide = false;
                    let result = columns.filter(e => e.columnid === all[i].columnid);
                    hide = result.length === 0;
                    let column = {
                        headerName: all[i].columnnm,
                        field: all[i].columnid,
                        colId: all[i].columnid,
                        hide: hide,
                        editable: function (params) {
                            return editcell(params);
                        },
                        datatype: all[i].datatype,
                        colinfo: all[i],
                        useValueParserForImport: true,
                    }
                    if (all[i].grouping) column['enableRowGroup'] = true
                    if (all[i].summary) column['aggFunc'] = '計'
                    if (!hide) {
                        if (!isEmpty(result.width)) column['width'] = result.width;
                        else {
                            if (all[i].width !== 0) column['width'] = all[i].width;
                        }
                        //    column['pinned'] = result.pin;
                    }
                    if (all[i].primary && !checkflg) {
                        column['checkboxSelection'] = true;
                        checkflg = true;
                    }
                    //if (all[i].datatype === CELLTYPE.MASTER) {
                    //    column['valueGetter'] = MasterValueGetter;
                    //}
                    AGRef.current.SetColDefTypeInfo(all[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : all[i].datatype, column);
                    colDef.push(column);
                }
            } catch (error) {
                console.log(error);
            }
            //前回レイアウト適用
            if (prelayout) {
                colDef = AGRef.current.GetColState(storagekey(), colDef);
            } else {
                if (!mainfitColumn) {   //列幅最適化でない
                    //列幅のみ適用
                    let newcolDef = AGRef.current.LoadColState(storagekey());
                    if (!isEmpty(newcolDef)) {
                        for (let i = 0; i < colDef.length; i++) {
                            let item = newcolDef.find(e => e.colId === colDef[i].colId);
                            if (!isEmpty(item)) colDef[i].width = item.width;
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < columns.length; i++) {
                let result = all.filter(e => e.columnid === columns[i].columnid);
                if (isEmpty(result)) continue;
                let column = {
                    headerName: columns[i].columnnm,
                    field: columns[i].columnid,
                    colId: columns[i].columnid,
                    hide: false,
                    editable: function (params) {
                        return editcell(params);
                    },
                    datatype: columns[i].datatype,
                    colinfo: columns[i],
                    width: columns[i].width,
                }
                if (columns[i].grouping) column['enableRowGroup'] = true
                if (columns[i].summary) column['aggFunc'] = '計'
                //column['width'] = result.width;
                if (all[i].primary && !checkflg) {
                    column['checkboxSelection'] = true;
                    checkflg = true;
                }
                AGRef.current.SetColDefTypeInfo(columns[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : columns[i].datatype, column);
                colDef.push(column);
            }
            //保存レイアウト項目以外を追加
            for (let i = 0; i < all.length; i++) {
                let hide = true;
                let result = columns.find(e => e.columnid === all[i].columnid);
                if (!isEmpty(result)) continue;
                let column = {
                    headerName: all[i].columnnm,
                    field: all[i].columnid,
                    colId: all[i].columnid,
                    hide: hide,
                    editable: function (params) {
                        return editcell(params);
                    },
                    datatype: all[i].datatype,
                    colinfo: all[i]
                }
                if (all[i].grouping) column['enableRowGroup'] = true
                if (all[i].summary) column['aggFunc'] = '計'
                AGRef.current.SetColDefTypeInfo(all[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : all[i].datatype, column);
                colDef.push(column);
            }
        }
        setcolumns(colDef);
    }
    //２段列定義
    function createColDef2(all, columns, prelayout, initlayout) {
        setglobaldata(stickykey, "");
        var colDef = [colDefsInit];     //RowNodeIdカラム
        if (prelayout || initlayout) {  //前回レイアウト or 既定レイアウト
            try {
                let group = "";
                let child = [];
                for (let i = 0; i < all.length; i++) {
                    let hide = false;
                    let result = columns.filter(e => e.columnid === all[i].columnid);
                    hide = result.length === 0;
                    let column = {
                        headerName: all[i].columnnm,
                        field: all[i].columnid,
                        colId: all[i].columnid,
                        hide: hide,
                        editable: function (params) {
                            return editcell(params);
                        },
                        datatype: all[i].datatype,
                        colinfo: all[i],
                    }
                    if (all[i].groupstate === 1) column['columnGroupShow'] = 'open'
                    if (all[i].groupstate === 2) column['columnGroupShow'] = 'close'
                    if (all[i].grouping) column['enableRowGroup'] = true
                    if (all[i].summary) column['aggFunc'] = '計'
                    if (!hide) {
                        column['width'] = result.width;
                    }
                    AGRef.current.SetColDefTypeInfo(all[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : all[i].datatype, column);
                    if (isEmpty(all[i].groupcolumn)) {
                        if (child.length !== 0) {
                            let groupcol = {
                                headerName: group, child: child,
                            };
                            colDef.push(groupcol);
                            child = [];
                        }
                        colDef.push(column);
                    } else {
                        if (group === all[i].groupcolumn || group === "") {
                            child.push(column);
                        } else {
                            let groupcol = {
                                headerName: group, child: child,
                            };
                            colDef.push(groupcol);
                            child = [];
                            child.push(column);
                        }
                    }
                    group = all[i].groupcolumn;
                }
                if (child.length !== 0) {
                    let groupcol = {
                        headerName: group, child: child,
                    };
                    colDef.push(groupcol);
                }
            } catch (error) {
                console.log(error);
            }
            //前回レイアウト適用
            if (prelayout) {
                //    colDef = AGRef.current.GetColState(storagekey(), colDef);
            }
        } else {
            let group = "";
            let child = [];
            for (let i = 0; i < columns.length; i++) {
                let result = all.filter(e => e.columnid === columns[i].columnid);
                if (isEmpty(result)) continue;
                let column = {
                    headerName: columns[i].columnnm,
                    field: columns[i].columnid,
                    colId: columns[i].columnid,
                    hide: false,
                    editable: function (params) {
                        return editcell(params);
                    },
                    datatype: columns[i].datatype,
                    colinfo: columns[i],
                }
                if (columns[i].grouping) column['enableRowGroup'] = true
                if (columns[i].summary) column['aggFunc'] = '計'
                column['width'] = result.width;
                AGRef.current.SetColDefTypeInfo(columns[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : columns[i].datatype, column);
                if (isEmpty(columns[i].groupcolumn) === "") {
                    if (child.length !== 0) {
                        let groupcol = { headerName: group, children: child };
                        colDef.push(groupcol);
                        group = columns[i].groupcolumn;
                        child = [];
                    }
                    colDef.push(column);
                } else {
                    if (group === columns[i].groupcolumn) {
                        child.push(column);
                    } else {
                        let groupcol = { headerName: group, children: child };
                        colDef.push(groupcol);
                        group = columns[i].groupcolumn;
                        child = [];
                    }
                }
            }
            if (child.length !== 0) {
                let groupcol = { headerName: group, children: child };
                colDef.push(groupcol);
            }
            //保存レイアウト項目以外を追加
            //    for (let i = 0; i < all.length; i++) {
            //        let hide = true;
            //        let result = columns.filter(e => e.columnid === all[i].columnid);
            //        if (isEmpty(result.length)) continue;
            //        let column = {
            //            headerName: all[i].columnnm,
            //            field: all[i].columnid,
            //            colId: all[i].columnid,
            //            hide: hide,
            //            editable: function (params) {
            //                return editcell(params);
            //            },
            //            datatype: all[i].datatype,
            //            colinfo: all[i]
            //        }
            //        if (all[i].grouping) column['enableRowGroup'] = true
            //        if (all[i].summary) column['aggFunc'] = '計'
            //        AGRef.current.SetColDefTypeInfo(all[i].format.indexOf('numstyle') !== -1 ? CELLTYPE.NUM : all[i].datatype, column);
            //        colDef.push(column);
            //    }
        }
        setcolumns(colDef);
    }
    function editcell(params, status) {
        if (isEmpty(status)) status = params.context.status;
        if (isEnabled(props.insertonly)) status = "INSERT";     //params.context.statusがVIEWのままになるため（暫定）
        if (isEmpty(params.colDef.colinfo)) return false;
        if (status === 'VIEW') {
            return myfield(params.colDef.colinfo);
        }
        let locked = isEnabled(params.colDef.colinfo.locked);
        let primary = isEnabled(params.colDef.colinfo.primary);
        let unchange = isEnabled(params.colDef.colinfo.unchange);
        if (status === 'INSERT') {
            if (!isEmpty(props.lockcell)) {
                let ret = props.lockcell(params, !locked, status, tabvalue);
                locked = !ret;
            }
            return !locked;
        }
        if (status === 'UPDATE') {
            let edit = !unchange && !primary && !locked && (tabvalue === params.colDef.colinfo.type || isEnabled(props.updatelockuncheck));  //編集可（主キーでない、ロックでない、自テーブル項目）
            if (!isEmpty(props.lockcell)) {
                edit = props.lockcell(params, edit, status, tabvalue);
            }
            return edit;
        }
        return false;
    }
    const aggFuncs = {
        '計': params => {
            let sum = 0;
            params.values.forEach(value => sum += NumConv(value));
            return sum;
        }
    };
    function showmenu() {
        setedittool(0);
        if (Operation(formstatus) === OP.ENTRY)
            props.entrycallback("close");
        AGRef.current.SaveColState(storagekey());
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
        setmenuopen(true);
    }
    function closemenu() {
        setmenuopen(false);
    }

    function Operation(status) {
        if (status === "VIEW" || status === "INSERT" || status === "UPDATE" || status === "MASONRY" || status === "CONDITION") return OP.LIST;
        return OP.ENTRY;
    }
    function ClearSheet(api) {
        const activeApi = isEmpty(api) ? gridApi : api;
        clearwarning();
        setsearchtaglist([]);
        if (isEmpty(activeApi)) return;
        setcolumns(AGRef.current.GetApplyColumnDefs(columns, activeApi));  //列状態を更新
        setsearchword("");
        activeApi.setGridOption("quickFilterText", "");
        activeApi.applyColumnState({ defaultState: { sort: null, rowGroup: false } });   //ソートクリア
        let count = 30;
        if (listtabs.length !== 0) {
            let tabinfo = listtabs.find(e => e.value === tabvalue);
            let initrow = NumConv(DicVal(tabinfo, "initrow", 0));
            if (initrow !== 0) {
                count = initrow === -1 ? 0 : initrow;
            }
        }
        AGRef.current.GridClear(count, activeApi, activeApi);
        fnc.current.modify(false);
    }
    function onCellDoubleClicked(params) {
        if (!isViewStatus) return;
        if (editcell(params)) return;
        if (params.node.group) return;
        if (formstatus === "CONDITION") return;     
        if (menuinfo.ctrls.indexOf("NAV4") !== -1 || menuinfo.ctrls.indexOf("NAV7") !== -1) return;   //アプリケーション制御
        if (!isEmpty(props.listcelldoubleclick)) {
            if (props.listcelldoubleclick(params)) return;
        }
        if (!isEnabled(props.entryform)) return;
        setentryrow([params.data]);
        if (EntryCall(params.data, null)) {
            dispatch(changestatus("ENTRY FORM"));
        }
        //    var option = null;
        //    if (isoption) {
        //        option = props.entrydataRef.current[listoption[0].columnid];
        //    }
        //    saveListOptionValuesForView();
        //    if (props.show(params.data, null, option)) {
        //        dispatch(changestatus("ENTRY FORM"));
        //    } else {
        //        listoptionViewSnapshotRef.current = null;
        //    }
    }
    function onCellClicked(params) {
        if (!isEmpty(props.oncellclicked)) props.oncellclicked(params);
    }
    function callChangeStatus(oldstatus, newstatus) {
        ChangeStatus(oldstatus, newstatus);
    }
    function ChangeStatus(oldstatus, newstatus, reload) {
        //if (reload === undefined) reload = entrymodify;
        setedittool(0);
        clearwarning();
        gridApi.stopEditing();
        if (oldstatus === "CONDITION" && (newstatus === "INSERT" || newstatus === "NEW FORM")) {
            cancelReturnStatusRef.current = "CONDITION";
        } else if (newstatus === "INSERT" || newstatus === "NEW FORM") {
            cancelReturnStatusRef.current = null;
        }
        const returnToCondition = newstatus === 'VIEW'
            && cancelReturnStatusRef.current === "CONDITION"
            && (oldstatus === "INSERT" || oldstatus === "NEW FORM");
        if (newstatus === "CONDITION") {
            setConditionCancelEnabled(true);
            if (Operation(oldstatus) === OP.ENTRY) {    //画面遷移から最初のLIST
                GetList(true);
            }
        }
        ColumninfoAppy();
        if (Operation(newstatus) !== OP.ENTRY && Operation(oldstatus) !== OP.ENTRY && newstatus !== 'MASONRY' && oldstatus !== 'MASONRY') {
            setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
        }
        if (newstatus === 'MASONRY') {
            setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
            fnc.current.masonrydata(AGRef.current.GetAfterFilterData());
            dispatch(changestatus(newstatus));
            return;
        }
        if (newstatus === 'VIEW') {
            //if (oldstatus === "CONDITION" || Operation(oldstatus) === OP.ENTRY) {
            //    restoreListOptionValues(listoptionViewSnapshotRef.current);
            //}
            if (oldstatus === "CONDITION" && isoption) {
                //シート変更が発生しないlistoption値を復元
                const snapshot = listoptionViewSnapshotRef.current;
                if (!isEmpty(snapshot)) {
                    const nextListOption = typeof listoptionRef.current === "object" && listoptionRef.current !== null
                        ? { ...listoptionRef.current }
                        : {};
                    var cols = listoption.filter(e => e.headerfix === 0);  //レイアウト読み込み必要カラム以外
                    cols.forEach(function (column) {
                        if (!isEmpty(snapshot[column.columnid])) {
                            nextListOption[column.columnid] = snapshot[column.columnid];
                        }
                    });
                    listoptionRef.current = nextListOption;
                }
            }
            let listupdate = false;
            if (Operation(oldstatus) === OP.ENTRY) {
                props.entrycallback("close");
                if (entrymodifyRef.current && tabvalue !== "0") {   //Entry Form更新かつ子テーブル
                    listupdate = true;
                }
                if (isEmpty(columninfo)) listupdate = true;     //Entry Formが直呼ばれた後
            }

            dispatch(clearform(false));
            if (returnToCondition) {
                let data = AGRef.current.GetStoreDataSource();
                gridApi.setGridOption("rowData", data);
            } else if (dbupdate || listupdate) {
                GetList(false);
            } else {
                if (Operation(oldstatus) === OP.LIST || reload) {
                    let data = AGRef.current.GetStoreDataSource();
                    gridApi.setGridOption("rowData", data);
                }
            }
            fnc.current.modify(false);
            setfileimp(false);
            if (returnToCondition) {
                setConditionCancelEnabled(false);
                dispatch(changestatus("CONDITION"));
            }
            cancelReturnStatusRef.current = null;
        } else {
            if (Operation(newstatus) === OP.ENTRY) {
                if (Operation(oldstatus) !== OP.ENTRY) {
                    //saveListOptionValuesForView();
                    setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
                    AGRef.current.SaveColState(storagekey());
                }
                let data = null;
                if (newstatus === "COPY FORM") {
                    dispatch(changestatus(newstatus));
                    return;
                }
                if (newstatus === "ENTRY FORM") {
                    let rowdata = AGRef.current.GetSelectrowdata();
                    if (rowdata.length === 0) {
                        fnc.current.warnmsg("データを選択してください");
                        return;
                    }
                    if (rowdata.length !== 1) {
                        fnc.current.warnmsg("複数行選択されてます");
                        return;
                    }
                    data = rowdata[0];
                }
                //ColumninfoAppy();
                if (EntryCall(data, null) === false) return;
            //    var option = null;
            //    if (isoption) {
            //        option = props.entrydataRef.current[listoption[0].columnid];
            //    }
            //    if (props.show(data,null, option) === false) return;
            }
            dispatch(changestatus(newstatus));
            if (newstatus === 'INSERT') {
                ClearSheet();
            }
            if (newstatus === 'UPDATE') {
                gridApi.applyColumnState({ defaultState: { rowGroup: false } });   //グルーピング解除
            }
        }
        if (Operation(oldstatus) === OP.ENTRY && callstatus === "MASONRY") {
            entrymodifyRef.current = false;
            ChangeStatus("VIEW","MASONRY");
            return;
        }
    }

    function IsFindTarget(column) {
        if (edittool===1) return true;  //検索 nocheck
        let params = {};
        if (isEmpty(props.lockcell)) {
            params["colDef"] = columns.find(e => e.field === column.field);
            return editcell(params, formstatus);
        } else {
            params["colDef"] = columns.find(e => e.field === column.field);
            let locked = isEnabled(params.colDef.colinfo.locked);
            return props.lockcell(params, !locked, formstatus, tabvalue);
        }
    }
    //mode:0=次検索 1:置換（フォーカスセルのみ）2:全置換 -1:再捜索
    function NextFindCell(rowIndex, colid, cols, nodes, mode ) {
        var findword = findwordRef.current.value;
        var loop = mode===-1;
        var find = mode===-1;
        if (!directionRef.current.checked || mode > 0) {    //下検索または置換
            for (let r = mode===-1?0:rowIndex; r < nodes.length; r++) {
                if (r === rowIndex || loop) {
                    let data = nodes[r].data;
                    for (let c = 0; c < cols.length; c++) {
                        if (!find && mode!==0 && cols[c].field === colid) {    //置換の場合フォーカスセルを含める
                            find = true;
                        }
                        if (find && cols[c].field in data) {
                            let value;
                            if (cols[c].datatype === CELLTYPE.STICKY) {
                                value = data[cols[c].field].note;
                            } else {
                                value = data[cols[c].field];
                            }
                            if (isEmpty(value)) continue;
                            if (matchRef.current.checked) {
                                if (value === findword) {
                                    if (IsFindTarget( cols[c])) {
                                        return { rowIndex: r, colId: cols[c].field };
                                    }
                                }
                            } else {
                                if (typeof (value) === typeof(1)) {
                                    value = value.toString();
                                }
                                if (value.indexOf(findword) !== -1) {
                                    if (IsFindTarget( cols[c])) {
                                        return { rowIndex: r, colId: cols[c].field };
                                    }
                                }
                            }
                        }
                        if (!find && cols[c].field === colid) {
                            find = true;
                        }
                    }
                    colid = cols[0].field;
                    loop = true;
                }
            }
        } else {    //前検索
            for (let r = mode===-1?nodes.length-1:rowIndex; r >= 0; r--) {
                if (r === rowIndex || loop) {
                    let data = nodes[r].data;
                    for (let c = cols.length - 1; c >= 0; c--) {
                        if (find && cols[c].field in data) {
                            let value;
                            if (cols[c].datatype === CELLTYPE.STICKY) {
                                value = data[cols[c].field].note;
                            } else {
                                value = data[cols[c].field];
                            }
                            if (isEmpty(value)) continue;
                            if (matchRef.current.checked) {
                                if (value === findword) {
                                    if (IsFindTarget( cols[c])) {
                                        return { rowIndex: r, colId: cols[c].field };
                                    }
                                }
                            } else {
                                if (value.indexOf(findword) !== -1) {
                                    if (IsFindTarget( cols[c])) {
                                        return { rowIndex: r, colId: cols[c].field };
                                    }
                                }
                            }
                        }
                        if (!find && cols[c].field === colid) {
                            find = true;
                        }
                    }
                    colid = cols[0].field;
                    loop = true;
                }
            }
        }
        return null;
    }

    //検索
    function SheetFind() {
        var cols, nodes;
        var focus = gridApi.getFocusedCell();
        var cell = null;
        if (!isEmpty(focus)) {
            cell = { rowIndex: focus.rowIndex };
            cell.column = { colId: focus.column.colId };
        }
        if (rangeRef.current.checked) {
            const ranges = gridApi.getCellRanges();
            nodes = AGRef.current.GetRangeSelectrownode(ranges);
            if (nodes.length === 0) {
                fnc.current.warnmsg("範囲を選択してください");
                return;
            }
            cols = AGRef.current.GetRangeColDef(ranges);
            //nodeのindexを取得
            if (!isEmpty(cell)) {
                cell.rowIndex = nodes.findIndex(e => e.rowIndex === cell.rowIndex);
                if (cell.rowIndex === -1) {
                    cell = null;
                } else {
                    if (!nodes.some(e => e.field === cell.column.colId)) {
                        cell.column.colId = cols[0].colId;
                    }
                }
            }
        } else {
            nodes = AGRef.current.GetAfterFilterNode();
            cols = AGRef.current.GetshownColinfos();
            //nodeのindex=rowIndex
        }
        if (cell === null) {
            cell = { rowIndex: directionRef.current.checked ? nodes.length - 1 : 0 }
            cell.column = { colId : cols[0].colId };
        }
        for (let i = 0; i <= 1; i++) {
            let target = NextFindCell(cell.rowIndex, cell.column.colId, cols, nodes, i===0?0:-1);    //範囲指定の場合再捜索
            if (target === null) {
                if (!rangeRef.current.checked) {
                    fnc.current.warnmsg(directionRef.current.checked ? "前方（↑）に一致するデータがありません" : "後方（↓）に一致するデータがありません");
                    gridApi.setFocusedCell(cell.rowIndex, cell.column.colId);
                    break;
                }
                if (i === 1) {
                    fnc.current.warnmsg("一致するデータがありません");
                }
            } else {
                let viewcols = gridColumnApi.getAllDisplayedVirtualColumns();
                let idx = viewcols.findIndex(e => e.colId === target.colId);
                if (idx === -1 || idx === viewcols.length) {
                    gridApi.ensureColumnVisible(target.colId, 'middle');
                }
                gridApi.setFocusedCell(nodes[target.rowIndex].rowIndex, target.colId);
                break;
            }
        }
    }
    //置換
    function SheetReplace() {
        var cols, nodes;
        var focus = gridApi.getFocusedCell();
        var cell = null;
        if (!isEmpty(focus)) {
            cell = { rowIndex: focus.rowIndex };
            cell.column = { colId: focus.column.colId };
        }
        if (rangeRef.current.checked) {
            const ranges = gridApi.getCellRanges();
            nodes = AGRef.current.GetRangeSelectrownode(ranges);
            if (nodes.length === 0) {
                fnc.current.warnmsg("範囲を選択してください");
                return;
            }
            cols = AGRef.current.GetRangeColDef(ranges);
            //nodeのindexを取得
            if (!isEmpty(cell)) {
                cell.rowIndex = nodes.findIndex(e => e.rowIndex === cell.rowIndex);
                if (cell.rowIndex === -1) {
                    cell = null;
                } else {
                    if (!nodes.some(e => e.field === cell.column.colId)) {
                        cell.column.colId = cols[0].colId;
                    }
                }
            }
        } else {
            nodes = AGRef.current.GetAfterFilterNode();
            cols = AGRef.current.GetshownColinfos();
        }
        if (cell === null) {
            cell = { rowIndex: directionRef.current.checked ? nodes.length - 1 : 0 }
            cell.column = { colId: cols[0].colId };
        }
        let target = NextFindCell(cell.rowIndex, cell.column.colId, cols, nodes,1);
        if (target === null) {
            fnc.current.warnmsg("一致するデータがありません");
            gridApi.setFocusedCell(cell.rowIndex, cell.column.colId);
        } else {
            let rowNode = gridApi.getDisplayedRowAtIndex(nodes[target.rowIndex].rowIndex);
            if (matchRef.current.checked) {
                rowNode.setDataValue(target.colId, replacewordRef.current.value);
            } else {
                let text = replaceall(rowNode.data[target.colId],findwordRef.current.value, replacewordRef.current.value);
                rowNode.setDataValue(target.colId, text);
            }
            //次を検索
            for (let i = 0; i <= 1; i++) {
                let nexttarget = NextFindCell(target.rowIndex, target.colId, cols, nodes, i===0?0:-1);
                if (nexttarget === null) {
                    if (!rangeRef.current.checked) break;
                } else {
                    let viewcols = gridColumnApi.getAllDisplayedVirtualColumns();
                    let idx = viewcols.findIndex(e => e.colId === nexttarget.colId);
                    if (idx === -1 || idx === viewcols.length) {
                        gridApi.ensureColumnVisible(nexttarget.colId, 'middle');
                    }
                    gridApi.setFocusedCell(nodes[nexttarget.rowIndex].rowIndex, nexttarget.colId);
                    break;
                }
            }
        }
    }
    //全置換
    function SheetReplaceAll() {
        var cols, nodes;
        if (rangeRef.current.checked) {
            const ranges = gridApi.getCellRanges();
            nodes = AGRef.current.GetRangeSelectrownode(ranges);
            cols = AGRef.current.GetRangeColDef(ranges);
            if (nodes.length === 0) {
                fnc.current.warnmsg("範囲を選択してください");
                return;
            }
        } else {
            nodes = AGRef.current.GetAfterFilterNode();
            cols = AGRef.current.GetshownColinfos();
        }
        var count = 0;
        var data = AGRef.current.GetDatasource();
        for (let i = 0; i < nodes.length; i++) {
            for (let c = 0; c < cols.length; c++) {
                if (!IsFindTarget(cols[c])) continue;
                var value = StringConv(nodes[i].data[cols[c].field]);
                if (matchRef.current.checked) {
                    if (value === findwordRef.current.value) {
                        var row = data.find(e => e.rowid === nodes[i].data.rowid);
                        row[cols[c].field] = replacewordRef.current.value;
                        count++;
                    }
                } else {
                    if (isEmpty(value)) continue;
                    if (value.indexOf(findwordRef.current.value) !== -1) {
                        let text = replaceall(value, findwordRef.current.value, replacewordRef.current.value);
                        var r = data.find(e => e.rowid === nodes[i].data.rowid);
                        r[cols[c].field] = text;
                        count++;
                    }
                }
            }
        }
        if (count === 0) fnc.current.warnmsg("置換対象データがありません");
        else {
            setRowData(data);
        }
    }


    //タグ追加
    function AddSearchTag() {
        let tagcol = AGRef.current.GetTagColumnInfo(columninfo);
        if (tagcol.length === 0) return;
        //マスタリスト
        let taglist = [];
        if (!isViewStatus) {
            for (let i = 0; i < tagcol.length; i++) {
                let tag = AGRef.current.GetTagDataList(tagcol[i].columnid, tagcol[i].dataid.indexOf("0") === -1 ? "" : "§");
                Array.prototype.push.apply(taglist, tag);
            }
        }
        let data = {
            dataid: tagcol[0].dataid,
            datatype: CELLTYPE.TAG,
            columnid: "SearchTag",  //検索結果event識別子
        };
       fnc.current.searchlistopen({
            label: "TAG",
            multiple: true,
            data: data,
            taglist: taglist,
           rowmode: false,
           doApply: setsearchitem
        });
    }
    //クイックサーチ
    function FilterSearch(value) {
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
        setsearchword(value);
        gridApi.setGridOption("quickFilterText", value);
    }
    //検索タグ削除
    function removeSearchTag(deletetag) {
        const newtags = searchtaglist.filter(function (tag) {
            return tag !== deletetag;
        });
        setsearchtaglist(newtags);
    }
    //検索タグ除外設定変更
    function changeSearchTag(changetag) {
        var newtags = [...searchtaglist];
        var tag = newtags.find(e => e.tag === changetag.tag);
        if (!isEmpty(tag))
            tag.mode = tag.mode === 0 ? 1 : 0;
        setsearchtaglist(newtags);
    }

    //検索条件パネルを開く
    function OpenSearchpanel() {
        //fnc.current.searchpanelopen({ items: searchitems, savekey: props.controller, doApply: searchexecute });
        setsearchpanelopen(true);
    }

    //レイアウト呼び出し
    function calllayout(layoutid) {
        fnc.current.postaxios('common/GetListColumns',
            { "controller": props.controller, "subkey": props.subkey, "type": tabvalue, "code": layoutid },
            {
                onSuccess: function (data) {
                    if (isEnabled(props.list)) {
                        AGRef.current.GridClear(0);
                    }
                    createColDef(data.colinfo, data.columns, false, data.initlayout.trim().length===0);
                    setcolumninfo(data.colinfo);
                    AGRef.current.SaveColState(storagekey());
                    fnc.current.wait(false);
               },
            }
        )
    }
    //レイアウト登録
    function savelayout(mode, layoutid) {
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
        fnc.current.postaxios('common/SaveLayout',
            {
                "controller": props.controller, "subkey": props.subkey, "type": tabvalue,
                "code": layoutid, "mode":mode,
                "coldef": AGRef.current.GetshownColDef()
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addlayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }

    //ToolTAGよりTAG追加
    function AddTagsCell(tags) {
        fnc.current.formdialogclose();
        const ranges = gridApi.getCellRanges();
        let columns = [];
        for (let i = 0; i < ranges[0].columns.length; i++) {
            let column = ranges[0].columns[i].colDef.colinfo;
            //if (column.datatype === CELLTYPE.TAG && ranges[0].columns[i].colDef.editable) {
            if (column.datatype === CELLTYPE.TAG && !column.locked) {
                columns.push(column.columnid);
            }
        }
        let min = ranges[0].startRow.rowIndex > ranges[0].endRow.rowIndex ? ranges[0].endRow.rowIndex : ranges[0].startRow.rowIndex;
        let max = ranges[0].startRow.rowIndex < ranges[0].endRow.rowIndex ? ranges[0].endRow.rowIndex : ranges[0].startRow.rowIndex;
        gridApi.forEachNodeAfterFilterAndSort(function (node) {
            if (node.rowIndex >= min && node.rowIndex <= max) {
                for (let i = 0; i < columns.length; i++) {
                    const colid = columns[i];
                    var tagcellvalue = node.data[colid];
                    var newtag = tagformat(tags + " " + tagcellvalue);
                    if (tagcellvalue.split(' ').length !== newtag.split(' ').length || tagcellvalue.length===0)     //TAG追加あり
                        node.setDataValue(colid, newtag);
                }
            }
        });
    }
    function onCellValueChanged(params) {
        if (params.newValue === params.oldValue) return;
        //if (formstatus === 'VIEW') return;

        fnc.current.modify();
        let colinfo = params.colDef.colinfo;
        if (colinfo === null) return;

        if (params.newValue !== "") {
            if (colinfo.datatype === CELLTYPE.MASTER || colinfo.datatype === CELLTYPE.MASTERREF ||
                colinfo.datatype === CELLTYPE.MASTERCODE || colinfo.datatype === CELLTYPE.MASTERASST) {
                if (!Suppress.current) {    //検索リスト選択以外
                    let rowNode = gridApi.getRowNode(params.data.rowid);
                    LinkFieldApply(colinfo, params.newValue, rowNode, params);
                }
            }
        }
        if (formstatus !== 'VIEW') {
            //計算処理 または結合文字列
            SetFormula();
        }
        if (!isEmpty(props.listcellchange)) {
            var ret = props.listcellchange(params, columninfo, GetListType());
            if (ret !== null) {
                let rowNode = gridApi.getRowNode(params.data.rowid);
                for (let key in ret) {
                    rowNode.setDataValue(key, ret[key]);
                }
            }
        }
        function SetFormula() {
            let formulalist = columninfo.filter(e => e.type === tabvalue && !isEmpty(e.formula));
            if (formulalist.length === 0) return;
            formulalist = formulalist.filter(e => e.formula.indexOf("[" + colinfo.columnid + "]") !== -1);
            if (formulalist.length === 0) return;

            let rowNode = gridApi.getRowNode(params.data.rowid);
            for (let i = 0; i < formulalist.length; i++) {
                let cell = formulalist[i];
                var target = columninfo.find(e => e.columnid === cell.columnid);
                let replaceval = params.newValue;
                if (target.datatype === CELLTYPE.NUMBER) {
                    if (isNaN(params.newValue)) replaceval = '0';
                } else {
                    if (isEmpty(params.newValue)) replaceval = '';
                }
                let formula = replaceall(cell.formula, "[" + colinfo.columnid + "]", replaceval);
                let fields = formula.match(/\[.*?\]/g);
                if (fields.length !== 0) {
                    for (let j = 0; j < fields.length; j++) {
                        let f = fields[j].replace("[", "").replace("]", "");
                        let value = "";
                        if (target.datatype === CELLTYPE.NUMBER) {
                            value = NumConv(rowNode.data[f]);
                        } else {
                            if (!isEmpty(rowNode.data[f])) value = rowNode.data[f];
                        }
                        formula = formula.replace(fields[j], value);
                    }
                }
                if (target.datatype === CELLTYPE.NUMBER) {
                    let result = Eval(formula);
                    rowNode.setDataValue(cell.columnid, result);
                } else {
                    rowNode.setDataValue(cell.columnid, formula);
                }
            }
        }
        if (props.changevalue) {
            props.changevalue(params);
        }
    }
    function AllSKU(column, allsku) {
        if (column.dataid === "d_prod" || column.dataid === "d_inst" || column.dataid === "m_matl" || column.dataid === "m_smatl") {
            var params = DicVal(column, "searchparam");
            if (isEmpty(params)) return allsku;
            let ret = DicVal(params, "allsku");
            if (isEmpty(ret)) return allsku;
            if (ret.toLowerCase() === "false") return false;
            return allsku;
        } else {
            return false;
        }
    }
    //masterlist selectitem
    function setsearchitem(e, mode,allsku) {
        gridApi.stopEditing();
        if (e.key === "SearchTag") {    //ヘッダツール検索TAG
            let newtag = [];
            const tags = e.value.split(" ");
            for (let i = 0; i < tags.length; i++) {
                newtag.push({ tag: tags[i], mode: 0 });
            }
            newtag = [...newtag, ...searchtaglist];
            newtag = removeDuplicates(newtag);
            setsearchtaglist(newtag);
            fnc.current.searchlistclose();
　          return;
        }
        let column = e.datainfo;
        if (column.datatype === CELLTYPE.TAG) {
            for (let i = 0; i < e.rowid.length; i++) {
                let rowNode = gridApi.getRowNode(e.rowid[i]);
                var tag = rowNode.data[e.key];
                if (mode === 0 || mode === 2) {   //追加0
                    let newtag = tagformat(e.value + " " + tag);
                    if (tag.split(' ').length !== newtag.split(' ').length || tag === "")     //TAG追加あり
                        rowNode.setDataValue(e.key, newtag);
                } else {            //削除
                    if (tag.length !== 0) {
                        let newtag = removetag(tag, e.value);
                        if (tag.split(' ').length !== newtag.split(' ').length || newtag.length === 0)     //TA削除あり
                            rowNode.setDataValue(e.key, newtag);
                    }
                }
            }
        } else if (column.datatype === CELLTYPE.STICKY) {
            for (let i = 0; i < e.rowid.length; i++) {
                let rowNode = gridApi.getRowNode(e.rowid[i]);
                rowNode.setDataValue(e.key, { "mark": e.value, "color": e.color });
            }
        } else if (column.datatype === CELLTYPE.DATE) {
            for (let i = 0; i < e.rowid.length; i++) {
                let rowNode = gridApi.getRowNode(e.rowid[i]);
                rowNode.setDataValue(e.key, toStringDate(e.value));
            }
        } else if (column.datatype === CELLTYPE.SEARCHYM) {
            for (let i = 0; i < e.rowid.length; i++) {
                let rowNode = gridApi.getRowNode(e.rowid[i]);
                rowNode.setDataValue(e.key, toStringYM(e.value));
            }
        } else if (column.datatype === CELLTYPE.YEAR) {
            for (let i = 0; i < e.rowid.length; i++) {
                let rowNode = gridApi.getRowNode(e.rowid[i]);
                rowNode.setDataValue(e.key, toStringYYYY(e.value));
            }
        } else if (column.history) {
            for (let i = 0; i < e.rowid.length; i++) {
                let rowNode = gridApi.getRowNode(e.rowid[i]);
                rowNode.setDataValue(e.key, e.items[0].data["code"]);
            }
        } else {
            //MasterData呼出を集約するか判定 (トリガー項目がある場合一括取得)
            let coldefs = [];
            //if (fnc.current.isSKU(column.dataid)) {
            //    Suppress.current = true;
            //    coldefs.push(e.colorinfo);
            //    coldefs.push(e.sizeinfo);
            //} else {
            //    if (!isEmpty(column)) {
            //        if (column.trigger.length !== 0) Suppress.current = true;
            //    }
            //    coldefs.push(column);
            //}
            if (!isEmpty(column)) {
                if (fnc.current.isSKU(column.dataid)) {
                    Suppress.current = true;
                    coldefs.push(e.colorinfo);
                    coldefs.push(e.sizeinfo);
                } else {
                    if (AllSKU(column, allsku)) {   //全SKUの場合
                        //行の全データを取得（トリガ情報取得）
                        let colinfos = columninfo.filter(e => e.type === tabvalue);
                        coldefs.push(column);
                        let colcolumn = colinfos.find(e => fnc.current.isSKUColor(e.dataid));
                        coldefs.push(colcolumn);
                        let sizecolumn = colinfos.find(e => fnc.current.isSKUSize(e.dataid));
                        coldefs.push(sizecolumn);
                        fnc.current.getAllSKUdata(coldefs, colinfos, e.value, (data) => allskucallback(data, e));
                        fnc.current.searchlistclose();
                        return;
                    }
                    if (column.trigger.length !== 0) Suppress.current = true;
                    coldefs.push(column);
                }
            }
            if (e.rowmode && e.items.length > 1) {
                //複数選択
                let currowNode = gridApi.getRowNode(e.currowid);   //呼出行
                let rowNode = gridApi.getRowNode(e.currowid);   //呼出行
                AGRef.current.SetRowSelect(e.currowid);
                if (mode === 0) {   //挿入
                    if (formstatus === "UPDATE") {
                        fnc.current.warnmsg("UPDATEでは挿入できません");
                        return;
                    }
                    let next = AGRef.current.NextrowNode(rowNode.data.rowid);
                    if (next !== null) {
                        let rowcount = gridApi.getDisplayedRowCount();
                        AGRef.current.insertRow(next.rowIndex, rowcount === 1 ? e.items.length : e.items.length - 1);
                    }
                }
                let rows = [];
                for (let i = 0; i < e.items.length; i++) {
                    if (i !== 0) {
                        let rowid = rowNode.data.rowid;
                        rowNode = AGRef.current.NextrowNode(rowid);
                        if (rowNode === null) {     //次行なし
                            if (formstatus === "UPDATE") break;
                            AGRef.current.newRow(e.items.length - i);  //足りない行追加
                            rowNode = AGRef.current.NextrowNode(rowid);
                            if (rowNode === null) break;
                        }
                        if (!isEmpty(column.keyinfo)) {  //d_prod_color etc..
                            let keys = column.keyinfo.split(",");
                            for (let j = 0; j < keys.length; j++) {
                                let c = keys[j].split("=")[1];
                                if (!isEmpty(c)) {   //関連キー情報セット
                                    rowNode.setDataValue(c, currowNode.data[c]);
                                    setTriggerfielddata(c, currowNode.data, rowNode);   //Trigger項目セット
                                }
                            }
                        }
                    }
                    if (fnc.current.isSKU(column.dataid)) {
                        //SKU
                        if (e.items[i].color !== null) {
                            let data = e.items[i].color;
                            rowNode.setDataValue(e.colorkey, (e.colorinfo.datatype === CELLTYPE.MASTERREF ? data[e.colorinfo.dbcolumn] : data.code));
                        //    LinkFieldApply(e.colorinfo, data.code, rowNode);
                        }
                        if (e.items[i].size !== null) {
                            let data = e.items[i].size;
                            rowNode.setDataValue(e.sizekey, (e.sizeinfo.datatype === CELLTYPE.MASTERREF ? data[e.sizeinfo.dbcolumn] : data.code));
                        //    LinkFieldApply(e.sizeinfo, data.code, rowNode);
                        }
                    } else {
                        //Basic
                        let data = e.items[i].data;
                        rowNode.setDataValue(e.key, (column.datatype === CELLTYPE.MASTERREF ? data[e.datainfo.dbcolumn] : data.code));
                    //    LinkFieldApply(column, data.code, rowNode);
                    }
                    let rowdata = rowNode.data;
                    if (!isEmpty(props.entrydataRef)) {
                        rowdata = { ...rowdata, ...props.entrydataRef.current };
                    }
                    rows.push(rowdata);
               }
                if (Suppress.current) {
                    //行の全データを取得
                    fnc.current.getRowMasterdata(coldefs, columninfo, rows, (data) => rowcallback(data, rows));
                }
            } else {
                let rows = [];
                //単一選択
                for (let i = 0; i < e.rowid.length; i++) {  //同一項目を選択行にセット
                    let rowNode = gridApi.getRowNode(e.rowid[i]);
                    if (fnc.current.isSKU(column.dataid)) {
                        //SKU
                        if (e.items[i].color !== null) {
                            let data = e.items[i].color;
                            rowNode.setDataValue(e.colorkey, (e.colorinfo.datatype === CELLTYPE.MASTERREF ? data[e.colorinfo.dbcolumn] : data.code));
                        }
                        if (e.items[i].size !== null) {
                            let data = e.items[i].size;
                            rowNode.setDataValue(e.sizekey, (e.sizeinfo.datatype === CELLTYPE.MASTERREF ? data[e.sizeinfo.dbcolumn] : data.code));
                        }
                    } else {
                        //Basic
                        rowNode.setDataValue(e.key, (column.datatype === CELLTYPE.MASTERREF ? e.items[0].data[e.datainfo.dbcolumn] : e.value));
                    }
                    let rowdata = rowNode.data;
                    if (!isEmpty(props.entrydataRef)) {
                        rowdata = { ...rowdata, ...props.entrydataRef.current };
                    }
                    rows.push(rowdata);
                }
                if (Suppress.current) {
                    //行の全データを取得
                    fnc.current.getRowMasterdata(coldefs, columninfo, rows, (data) => rowcallback(data, rows));
                }
            }
        }
        fnc.current.searchlistclose();
    }
    function setTriggerfielddata(colid, data, rowNode) {
        let col = columninfo.find(e => e.columnid === colid);
        if (isEmpty(col.trigger)) return;
        for (let i = 0; i < col.trigger.length; i++) {
            try {
                if (!isEmpty(data)) {
                    rowNode.setDataValue(col.trigger[i].columnid, data[col.trigger[i].columnid]);
                //    rowNode.setDataValue(col.trigger[i].columnid, data[col.trigger[i].dbcolumn]);
                }
            } catch { }
        }
    }
    function allskucallback(data, e) {
        console.log("*** allskucallback ***");
        if (isEmpty(AGRef.current)) return;
        let currowNode = gridApi.getRowNode(e.currowid);   //呼出行
        AGRef.current.SetRowSelect(e.currowid);
        let next = AGRef.current.NextrowNode(currowNode.data.rowid);
        if (next !== null) {
            let rowcount = gridApi.getDisplayedRowCount();
            AGRef.current.insertRow(next.rowIndex, rowcount === 1 ? data.length : data.length - 1);
        }
        let rowNode = gridApi.getRowNode(e.currowid);   //呼出行
        var rows = [];
        for (let i = 0; i < data.length; i++) {
            if (i !== 0) {
                let rowid = rowNode.data.rowid;
                rowNode = AGRef.current.NextrowNode(rowid);
                if (rowNode === null) {     //次行なし
                    AGRef.current.newRow(data.length);  //足りない行追加
                    rowNode = AGRef.current.NextrowNode(rowid);
                    if (rowNode === null) break;
                }
            }
            let newdata = { ...rowNode.data, ...data[i] };
            if (!isEmpty(props.entrydataRef)) {
                newdata = { ...newdata, ...props.entrydataRef.current };
            }
            if (!isEmpty(props.rowdatachange)) {
                props.rowdatachange(newdata, columninfo);
            }
            rowNode.setData(newdata);
            rows.push(newdata);
        }
        //props.dataRef.current = AGRef.current.GetDatasource(gridApi);
        fnc.current.modify(true);
        fnc.current.wait(false);
    }
    function rowcallback(data, targets, params) {
        if (isEmpty(AGRef.current)) return;
        let src = AGRef.current.GetDatasource(gridApi);
        for (let r = 0; r < data.length; r++) {
            let row = src.find(e => e.rowid === data[r].rowid);
            if (isEmpty(row)) continue;
            for (let key in data[r]) {
                row[key] = data[r][key];
            }
        }
        for (let i = 0; i < targets.length; i++) {
            let rowNode = gridApi.getRowNode(targets[i].rowid);
            let newData = src.find(e => e.rowid === targets[i].rowid);
            if (!isEmpty(props.rowdatachange)) {
                props.rowdatachange(newData, columninfo);
            }
            rowNode.setData(newData);
        }
        fnc.current.wait(false);
        Suppress.current = false;
    }
    function LinkFieldApply(colinfo, value, rowNode, params) {
        //参照カラムを取得
        let others = colinfo.trigger;
        if (colinfo.datatype === CELLTYPE.MASTER) {
            others = [...colinfo.trigger, ...[{ columnid: colinfo.columnid, dbcolumn: colinfo.dbcolumn }]];
        }
        let keyinfo = "";
        if (colinfo.keyinfo !== "" && colinfo.datatype !== CELLTYPE.SELECT) {
            keyinfo = colinfo.keyinfo.split("=")[0] + "=" + rowNode.data[colinfo.keyinfo.split("=")[1]];
        }
        if (!fnc.current.existMaster(colinfo.dataid, value, keyinfo)) {
            //サーバーより情報を取得
            if (isEmpty(rowNode)) return;
            let rowdata = rowNode.data;
            if (!isEmpty(props.entrydataRef)) {
                rowdata = { ...rowdata, ...props.entrydataRef.current };
            }
            let sku = columninfo.filter(e => fnc.current.isSKU(e.dataid));
            if (sku.length !== 0 && (colinfo.dataid === "d_prod" || colinfo.dataid === "d_inst" || colinfo.dataid === "m_matl" || colinfo.dataid === "m_smatl"
                                 || colinfo.dataid === "d_porder_row")) {
                //行の全データを取得
                let colinfos = columninfo.filter(e => e.type === props.type);
                fnc.current.getRowMasterdata([colinfo], colinfos, [rowdata], (data) => rowcallback(data, [rowNode.data], params));
            } else {
                fnc.current.getMasterdata(colinfo.dataid, value, keyinfo, others, rowdata, (data) => callback(data, colinfo, rowNode));
            }
            if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
        } else {
            if (colinfo.datatype === CELLTYPE.MASTERREF) {
                //名称置き換え
                let data = fnc.current.getMaster(colinfo.dataid, value, keyinfo);
                rowNode.setDataValue(colinfo.columnid, data[colinfo.dbcolumn]);
                if (others.length === 0) {
                    if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
                }
            }
            if (others.length !== 0) {  //関連セットするデータあり
                let data = fnc.current.getMaster(colinfo.dataid, value, keyinfo);
                //すべての項目が揃っているかチェック
                let exist = true;
                for (let i = 0; i < others.length; i++) {
                    let key = others[i].dbcolumn;
                    if (key.toUpperCase() === 'NULL') continue;    //ブランクにする設定
                    if (key.indexOf('dbo') !== -1) {
                        key = 'fnc_' + colinfo.columnid;
                    }
                    if (data[key] === undefined) {
                        exist = false; break;
                    }
                }
                if (exist) {
                    setLinkfielddata(colinfo, data, rowNode);
                    if (!isEmpty(props.ValueChanged) && !Suppress.current) props.ValueChanged(params);
                } else {
                    let rowdata = rowNode.data;
                    let sku = columninfo.filter(e => fnc.current.isSKU(e.dataid));
                    if (sku.length !== 0 && (colinfo.dataid === "d_prod" || colinfo.dataid === "d_inst" || colinfo.dataid === "m_matl" || colinfo.dataid === "m_smatl"
                        || colinfo.dataid === "d_porder_row")) {
                        //行の全データを取得
                        fnc.current.getRowMasterdata([colinfo], columninfo, [rowdata], (data) => rowcallback(data, [rowNode.data], params));
                    } else {
                        //サーバーより情報を取得
                        fnc.current.getMasterdata(colinfo.dataid, value, keyinfo, others, rowdata, (data) => callback(data, colinfo, rowNode));
                    }
                }
            }
        }
        function callback(data, colinfo, rowNode) {
            if (!isEmpty(data) && fnc.current !== null) {
                fnc.current.setMaster(data);
            }
            if (rowNode !== undefined) {
                if (colinfo.datatype === CELLTYPE.MASTER) {
                    //セル内名称表示
                    var params = {
                        suppressFlash: true,
                        rowNodes: [rowNode],
                    };
                    gridApi.refreshCells(params);
                }
                if (!isEmpty(data)) {
                    if (colinfo.datatype === CELLTYPE.MASTERREF) {
                        //名称置き換え
                        rowNode.setDataValue(colinfo.columnid, data[colinfo.dbcolumn]);
                    }
                }
                setLinkfielddata(colinfo, data, rowNode);
                fnc.current.wait(false);
            }
        }
    }
    function setLinkfielddata(col, data, rowNode) {
        if (isEmpty(col.trigger)) return;
        for (let i = 0; i < col.trigger.length; i++) {
            try {
                if (col.trigger[i].dbcolumn.toUpperCase() === 'NULL') {
                    //ブランクにする
                    rowNode.setDataValue(col.trigger[i].columnid, "");
                    continue;
                }
                if (!isEmpty(data)) {
                    if (col.trigger[i].dbcolumn.indexOf("dbo") !== -1) {
                        //function
                        rowNode.setDataValue(col.trigger[i].columnid, data["fnc_" + col.trigger[i].columnid]);
                    } else {
                        rowNode.setDataValue(col.trigger[i].columnid, data[col.trigger[i].dbcolumn]);
                    }
                } else {
                    //マスタにない場合でロックセルの場合クリア
                    let coldef = columninfo.find(e => e.columnid === col.trigger[i].columnid);
                    if (!isEmpty(coldef)) {
                        if (coldef.locked) {
                            rowNode.setDataValue(col.trigger[i].columnid, "");
                        }
                    }
                }
            } catch { }
        }
    }
    function onfilterChanged() {
        if (formstatus === "MASONRY")
            fnc.current.masonrydata(AGRef.current.GetAfterFilterData());
    }
    function stickyfield() {
        if (isEmpty(columninfo)) return "";
        let col = columninfo.find(e => e.datatype === CELLTYPE.STICKY)
        if (!isEmpty(col)) return col.columnid;
        return "";
    }
    function memofield() {
        if (!isEmpty(props.primaryid)) {
            let key = props.primaryid + "_memo";
            if (isEmpty(columninfo)) return key;
            let col = columninfo.find(e => e.columnid === key)
            if (!isEmpty(col)) return col.columnid;
        } else {
            let col = columninfo.find(e => e.columnid.indexOf("_memo") !== -1)
            if (!isEmpty(col)) return col.columnid;
        }
        return "";
    }
   function primarykey() {
        if (isEmpty(columninfo)) return "";
        let col = columninfo.find(e => e.primary)
        if (!isEmpty(col)) return col.columnid;
        return "";
    }

    //列幅変更
    function ColumnResized(param) {
        if (param.source !== "uiColumnDragged") return;
        if (param.finished) {
            ColumninfoAppy();
        }
    }
    //項目表示/非表示
    function ColumnVisible(e) {
        if (e.source === "gridOptionsChanged") return;
        ColumninfoAppy(e);
        if (isEnabled(props.list) && !isEnabled(props.noclear)) {
            AGRef.current.GridClear(0);
        }
    }
    //列情報適用
    function ColumninfoAppy(e) {
        AGRef.current.SaveColState(storagekey());
        //保留　23/5/5　２段列の場合不正
    //    let source = "";
    //    if (!isEmpty(e))  source = e.source;
    //    if (source === 'uiColumnDragged' || source === "")     //toolpanel以外の操作（toolpanelが閉じられてしまうため）
    //        setcolumns(AGRef.current.GetApplyColumnDefs(columns));
    }
    //列最適化
    function GridColumnsChanged(params) {
        ApplyPendingInsertOnlyClear(params.api);
        if (params.columnApi === null) return;
        if (!mainfitColumn) return;
        if (rowData.length === 0) return;
        var allColumnIds = [];
        params.api.getAllGridColumns().forEach(function (column) {
            if (column.colId !== 'grip')
                allColumnIds.push(column.colId);
        });
        params.api.autoSizeColumns(allColumnIds, false);
    }

    function PasteStart(e) {
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));
    }

    function normalizeClipboardData(data) {
        if (isEmpty(data)) return [];
        let newdata = [...data];
        while (newdata.length > 1 && newdata[newdata.length - 1].every(value => value === '' || value === null || value === undefined)) {
            newdata.pop();
        }
        return newdata;
    }

    function processDataFromClipboard(params) {
        let data = normalizeClipboardData(params.data);
        if (data.length === 0) return data;

        PasteStart();

        if (isEmpty(AGRef.current)) {
            return data;
        }

        let focusedCell = params.api.getFocusedCell();
        if (isEmpty(focusedCell)) return data;

        let requiredRows = focusedCell.rowIndex + data.length;
        let displayedRows = params.api.getDisplayedRowCount();
        let addrows = requiredRows - displayedRows;
        if (addrows > 0) {
            AGRef.current.newRow(addrows, params.api, gridColumnApi);
        }
        return data;
    }

    function BodyScrollEnd(params) {
        if (params.direction !== 'horizontal') return;
        if (!mainfitColumn) return;
        if (params.columnApi === null) return;
        if (rowData.length === 0) return;
        if (!isEmpty(scrollLeftRef.current)) {
            if (scrollLeftRef.current >= params.left) return;    //１度実行した
        }
        scrollLeftRef.current = params.left;

        var allColumnIds = [];
        params.api.getAllGridColumns().forEach(function (column) {
            if (column.colId !== 'grip')
                allColumnIds.push(column.colId);
        });
        params.api.autoSizeColumns(allColumnIds, false);
    }
    function ApplyPendingInsertOnlyClear(api) {
        if (!pendingInsertOnlyClearRef.current) return;
        if (columns.length <= 1) return;
        if (isEmpty(api)) return;
        if (api.getColumnState().length <= 1) return;
        if (props.tabs === true && listtabs.length === 0) return;
        Interval(1, () => {
            if (!pendingInsertOnlyClearRef.current) return;
            pendingInsertOnlyClearRef.current = false;
            ClearSheet(api);
        });
    }
    function RowDataUpdated(params) {
        ApplyPendingInsertOnlyClear(params.api);
        if (props.RowDataUpdated) props.RowDataUpdated(params.api, listoptionRef.current);

    }
    function ColumnGroupOpened(params) {
        if (!params.columnGroup.expanded) return;
        if (params.columnApi === null) return;
        if (rowData.length === 0) return;
        if (!mainfitColumn) return;
        var allColumnIds = [];
        for(let i = 0; i < params.columnGroup.children.length; i++) {
            allColumnIds.push(params.columnGroup.children[i].colId);
        }
        params.api.autoSizeColumns(allColumnIds, false);
    }
    //TAG検索
    function isExternalFilterPresent() {
        try {
            let data = getglobaldata(tagkey);
            if (isEmpty(data)) return false;
            return data.length !== 0;
        } catch (error) {
            return false;
        }
    };
    function doesExternalFilterPass(node) {
        let taglist = getglobaldata(tagkey);
        if (taglist.length === 0) return true;
        let taginfo = AGRef.current.GetTagColumnInfo(columninfo);
        //検索TAGによるFilter
        let rowtag = "";
        for (let i = 0; i < taginfo.length; i++) {
            if (isEmpty(node.data[taginfo[i].columnid])) continue;
            rowtag += (i === 0 ? '' : ' ') + node.data[taginfo[i].columnid];
        }
        let tags = rowtag.split(' ');
        //除外Tag
        let exclude = taglist.filter(function (taglist) {
            return taglist.mode === 1;
        });
        for (let i = 0; i < exclude.length; i++) {
            if (tags.indexOf(exclude[i].tag) !== -1) //除外TAG有り
                return false;
        }
        //抽出Tag
        let include = taglist.filter(function (taglist) {
            return taglist.mode === 0;
        });
        if (include.length === 0) return true;
        for (let i = 0; i < include.length; i++) {
            if (tags.indexOf(include[i].tag) !== -1) //検索TAG有り
                return true;                 
        }
        return false;
    };
    function valueParser(params) {
        let colinfo = params.colDef.colinfo;
        if (colinfo === null) return params.newValue;
        if (params.newValue === '') {
            return params.newValue;
        }

        if (colinfo.datatype === CELLTYPE.TEXT) {
            if (colinfo.length !== 0) {
                if (params.newValue.length > colinfo.length)
                    params.newValue = params.newValue.substring(0, colinfo.length);
                if (isNumber(params.newValue) && colinfo.format.indexOf('padzero') !== -1) {
                    //ゼロサプレス
                    params.newValue = PadZero(params.newValue, colinfo.length);
                }
            }
        }
        if (colinfo.datatype === CELLTYPE.NUM) {
            if (!isFinite(params.newValue)) {
                if (props.preserveInvalidNumericInput)
                    return params.newValue;

                return '';
            }

            let num = Floor(Number(params.newValue), colinfo.decimalplace);
            if (colinfo.length !== 0 && colinfo.length < getInteferPointLength(num)) {
                //入力桁数が指定桁をオーバーしている場合
                num = getFirstDigits(num, colinfo.length)
            }
            return num;
        }
        if (colinfo.datatype === CELLTYPE.DATE) {
            try {
                if (!isDate(params.newValue)) return '';
                params.newValue = FormatDate(params.newValue);
            } catch {
                return '';
            }
        }
        if (colinfo.datatype === CELLTYPE.SEARCHYM) {
            try {
                params.newValue = trim(toHalfWidth(String(params.newValue)));
                if (/^\d{4}\/\d{2}$/.test(params.newValue)) {
                    let month = Number(params.newValue.substring(5, 7));
                    if (month < 1 || month > 12) return '';
                } else if (/^\d{6}$/.test(params.newValue)) {
                    let month = Number(params.newValue.substring(4, 6));
                    if (month < 1 || month > 12) return '';
                    params.newValue = params.newValue.substring(0, 4) + "/" + params.newValue.substring(4, 6);
                } else {
                    if (!isDate(params.newValue)) return '';
                    params.newValue = FormatDate(params.newValue).substring(0, 7);
                }
            } catch {
                return '';
            }
        }
        if (colinfo.datatype === CELLTYPE.MASTER || colinfo.datatype === CELLTYPE.MASTERCODE || colinfo.primary) {
            if (isEmpty(params.newValue)) return '';
            //半角変換およびスペース削除
            params.newValue = trim(toHalfWidth(params.newValue));
            if (colinfo.length !== 0) {
                if (params.newValue.length > colinfo.length)
                    params.newValue = params.newValue.substring(0, colinfo.length);
                if (isNumber(params.newValue) && colinfo.format.indexOf('padzero') !== -1) {
                    //ゼロサプレス
                    params.newValue = PadZero(params.newValue, colinfo.length);
                }
            }
        }
        if (colinfo.datatype === CELLTYPE.SELECT || colinfo.datatype === CELLTYPE.SPIN) {
            let result = colinfo.options.find(e => e.code === params.newValue);
            if (isEmpty(result))
                return '';
        }
        if (colinfo.datatype === CELLTYPE.TAG) {
            return tagformat(params.newValue);
        }
        return params.newValue;
    }
    function valueFormatter(params) {
        if (params.value == null) return null;
        if (params.value === '') return '';
        let colinfo = params.colDef.colinfo;
        if (colinfo === null) return params.value;
        try {
            if (colinfo.datatype === CELLTYPE.NUM) {
                var number = Number(params.value);

                if (props.preserveInvalidNumericInput &&
                    isNaN(number))
                    return params.value;

                return numformat(number, colinfo);
            }
            if (colinfo.datatype === CELLTYPE.MASTERCODE && colinfo.format.indexOf('numstyle') !== -1) {
                return numformat(Number(params.value), colinfo);
            }
            if (colinfo.datatype === CELLTYPE.MASTER) {
                if (formstatus === 'VIEW') {
                    if (!isEmpty(colinfo.dbcolumn)) {
                        if (isEmpty(params.data)) {
                            return GroupFooterValue(params);    //Grouping cell
                        } else {
                            return params.value + ":" + params.data[params.colDef.colId + "_nm"];
                        }
                    }
                } else {
                    if (params.value === DicVal(params.data, params.colDef.colId + "_cd")) {    //変更されていない
                        return params.value + ":" + params.data[params.colDef.colId + "_nm"];
                    }
                    let keyinfo = "";
                    if (colinfo.keyinfo !== "" && colinfo.datatype !== CELLTYPE.SELECT) {
                        keyinfo = colinfo.keyinfo.split("=")[0] + "=" + params.data[colinfo.keyinfo.split("=")[1]];
                    }
                    let data = fnc.current.getMaster(colinfo.dataid, params.value, keyinfo);
                    if (data !== null) {
                        return params.value + ":" + data[colinfo.dbcolumn];
                    }
                }
                return params.value;
            }
            if (colinfo.datatype === CELLTYPE.SELECT || colinfo.datatype === CELLTYPE.SPIN) {
                return selectformat(params.value, colinfo);
            }
        } catch {
            return params.value;
        }
        return params.value;
    }

    function cellEditorSelector(params) {
        let colinfo = params.colDef.colinfo;
        if (colinfo.datatype === CELLTYPE.TEXTAREA) {
            return {
                component: "agLargeTextCellEditor",
                params: { maxLength: 5000 },
                popup: true,
            };
        }
        return {component: "agTextCellEditor"};
    }

    function modifyfield(params) {
        if (fileimp) return false;
        if (!(formstatus === 'UPDATE' || params.colDef.colinfo.datatype === CELLTYPE.STICKY)) return false;
        const field = params.colDef.colId;
        const result = params.context.rowData.find(e => e.rowid === params.node.id);
        if (isEmpty(result)) return false;
        if (params.colDef.colinfo.datatype !== CELLTYPE.STICKY) {
            return params.value !== result[field];
        } else {
            if (params.value === result[field]) return false;
            if (isEmpty(params.value) === isEmpty(result[field])) return false;
            if (stickynote(params.value) === stickynote(result[field]) &&
                stickymark(params.value) === stickymark(result[field]) &&
                stickycolor(params.value) === stickycolor(result[field])) return true;
            else return false;
        }
    }
    const excelStyles = [
        {
            id: "exag_rowgroup",
            interior: {
                color: "#b5e6b5",
                pattern: "Solid"
            }
        },
        {
            id: "exag_string",
            dataType: 'String'
        },
        {
            id: "exag_number",
            numberFormat: { format: "#,###" }
        },
    ];
    const cellClassRules = {
        'lockcolumn': function (params) {
            if (params.context.status === "VIEW" || params.context.status === "CONDITION") return false;
            if (params.context.status === "UPDATE") {
                if (menuinfo.ctrls.indexOf("UPSAVE") !== -1) return false;   //更新なし
            }
            return !editcell(params);
        },
        'exag_change': function (params) {
            if (!modifyfield(params)) return false;
            return params.value !== '';
        },
        'exag_changebk': function (params) {
            if (!modifyfield(params)) return false;
            if (params.colDef.colinfo.datatype !== CELLTYPE.STICKY) {
                return params.value === '';
            }else {
                return stickynote(params.value) === '';

            }
        },
        'exag_rowgroup': function (params) {
            return params.node.group;
        },
        'exag_number': function (params) {
            if (isEmpty(params.colDef.colinfo)) return false;
            return params.colDef.colinfo.datatype === CELLTYPE.NUM;
        },
        'exag_string': function (params) {
            if (isEmpty(params.colDef.colinfo)) return true;
            return params.colDef.colinfo.datatype !== CELLTYPE.NUM;
        },
    }
    const getRowStyle = useCallback((params) => {
        if (params.node.rowPinned) {
            return { background: params.context.theme.body.accentback };
        }
        if (!isEmpty(props.exRowStyle)) {
            return props.exRowStyle(params);
        }
    }, []);


    function getRowHeight(params) {
        return isEmpty(rowHeight) ? undefined : rowHeight;
    };
    function copyicon(type) {
        switch (type) {
            case 0:
                return (
                    '<i class="material-icons min">content_copy</i>'
                );
            case 1:
                return (
                    '<i class="material-icons min">copy_all</i>'
                );
            case 2:
                return (
                    '<i class="material-icons min">push_pin</i>'
                );
            default:
                return null;
        }
    }
    function getContextMenuItems(params){
        var result = [
            'cut',
            'paste',
            'copy',
            'copyWithHeaders',
            {
                name: '選択行のコピー',
                icon: copyicon(1),
                action: function () {
                    params.api.copySelectedRowsToClipboard(false, false);
                },
            },
            'separator',
            {
                name: '全選択',
                action: function () {
                    params.api.selectAllFiltered();
                },
            },
            {
                name: '選択解除',
                action: function () {
                    params.api.deselectAll();
                },
            },
            {
                name: '選択行反転',
                action: function () {
                    params.api.forEachNodeAfterFilter(node => node.isSelected() ? node.setSelected(false) : node.setSelected(true));
                },
            },
            'separator',
        ];
        if (formstatus === "INSERT") {
            result.push(
                {
                    name: '行挿入',
                    tooltip: '選択位置に選択行数分新規行を挿入します',
                    action: function () {
                        var selectedRows = params.api.getSelectedNodes();
                        if (!selectedRows || selectedRows.length === 0) {
                            fnc.current.warnmsg("行を選択してください");
                            return;
                        }
                        let addindex = selectedRows[0].rowIndex;
                        AGRef.current.insertRow(addindex, selectedRows.length);
                    },
                }
            );
            result.push(
                {
                    name: '行追加',
                    tooltip: 'シート末尾に行を追加します',
                    subMenu: [
                        {
                            name: '１行',
                            action: function () { AGRef.current.newRow(1); },
                        },
                        {
                            name: '10行',
                            action: function () { AGRef.current.newRow(10); },
                        },
                        {
                            name: '50行',
                            action: function () { AGRef.current.newRow(50); },
                        },
                    ]
                });
        }
        result.push(
            {
                name: '行削除',
                tooltip: 'シートから選択行を削除します。※データは削除されません',
                action: function () {
                    const selectedRows = params.api.getSelectedRows();
                    if (!selectedRows || selectedRows.length === 0) {
                        fnc.current.warnmsg("行を選択してください");
                        return;
                    }
                    params.api.applyTransaction({ remove: selectedRows });
                },
            });
        result.push('separator');
        result.push(
            {
                name: '検索',
                tooltip: 'シート内の検索を行います',
                action: function () {
                    const ranges = gridApi.getCellRanges();
                    if (ranges[0].columns.length === 1 && ranges[0].startRow === ranges[0].endRow) {
                        setDefaultrange(false);
                    } else {
                        setDefaultrange(true);
                    }
                    setedittool(1);
                },
            });
        if (!isViewStatus) {
            result.push(
                {
                    name: '置換',
                    tooltip: 'シート内の置換を行います',
                    action: function () {
                        const ranges = gridApi.getCellRanges();
                        if (isEmpty(ranges)) {
                            setDefaultrange(false);
                        } else {
                            if (ranges.length === 0) {
                                setDefaultrange(false);
                            } else {
                                if (ranges[0].columns.length === 1 && ranges[0].startRow === ranges[0].endRow) {
                                    setDefaultrange(false);
                                } else {
                                    setDefaultrange(true);
                                }
                            }
                        }
                        setedittool(2);
                    },
                });
        }
        result.push('separator');
        result.push(
            {
                name: '行の高さ',
                subMenu: [
                    {
                        name: '低',
                        action: function () {
                            params.api.forEachNode(function (rowNode) {
                                rowNode.setRowHeight(22);
                            });
                            params.api.onRowHeightChanged();
                            AGRef.current.SaveRowHeight(storagekey(), 22);
                        },
                    },
                    {
                        name: '通常',
                        action: function () {
                            params.api.forEachNode(function (rowNode) {
                                rowNode.setRowHeight(28);
                            });
                            params.api.onRowHeightChanged();
                            AGRef.current.SaveRowHeight(storagekey(), null);
                        },
                    },
                    {
                        name: '中',
                        action: function () {
                            params.api.forEachNode(function (rowNode) {
                                rowNode.setRowHeight(80);
                            });
                            params.api.onRowHeightChanged();
                            AGRef.current.SaveRowHeight(storagekey(), 80);
                        },
                    },
                    {
                        name: '高',
                        action: function () {
                            params.api.forEachNode(function (rowNode) {
                                rowNode.setRowHeight(120);
                            });
                            params.api.onRowHeightChanged();
                            AGRef.current.SaveRowHeight(storagekey(), 120);
                        },
                    },
                ]
            }
        );
        result.push('separator');
        result.push(
            {
                name: 'TAG追加',
                tooltip: '選択セルにTAGの追加を行います',
                action: function () {
                    fnc.current.clearconvdescription();
                    const ranges = params.api.getCellRanges();
                    if (ranges.length === 0) {
                        fnc.current.warnmsg("対象セルを選択してください");
                        return;
                    }
                    let columns = [];
                    for (let i = 0; i < ranges[0].columns.length; i++) {
                        let column = ranges[0].columns[i].colDef.colinfo;
                        //if (column.datatype === CELLTYPE.TAG && ranges[0].columns[i].colDef.editable) {
                        if (column.datatype === CELLTYPE.TAG && !column.locked) {
                            columns.push(column);
                        }
                    }
                    if (columns.length === 0) {
                        fnc.current.warnmsg("TAG項目が含まれていません");
                        return;
                    }
                    fnc.current.formdialogopen({ title: "TAG追加", inputname:"TAG",placeholder: "スペース区切りで複数TAG入力できます", onApply: (param)=>AddTagsCell(param) });
                },
            });
        if (!isViewStatus) {
        //    result.push('separator');
        //    result.push(
        //        {
        //            name: 'マスタコード変換',
        //            tooltip: 'シート内容からマスタコードを取得しセットします',
        //            action: function () {
        //                fnc.current.clearconvdescription();
        //                const ranges = params.api.getCellRanges();
        //                if (ranges.length === 0) {
        //                    fnc.current.warnmsg("変換対象セルを選択してください");
        //                    return;
        //                }
        //                let columns = [];
        //                for (let i = 0; i < ranges[0].columns.length; i++) {
        //                    let column = ranges[0].columns[i].colDef.colinfo;
        //                    if (column.datatype === CELLTYPE.MASTER || column.datatype === CELLTYPE.MASTERCODE || column.datatype === CELLTYPE.MASTERASST) {
        //                        columns.push(column);
        //                    }
        //                }
        //                if (columns.length === 0) {
        //                    fnc.current.warnmsg("変換対象項目が含まれていません。マスタ項目を選択してください");
        //                    return;
        //                }
        //                let rows = AGRef.current.GetRangeSelectrowdata(ranges);
        //                fnc.current.postaxios('common/MasterConvert', { rowdata: rows, columns: columns },
        //                    {
        //                        onSuccess: function (data) {
        //                            if (data.warning.length === 0) {
        //                                fnc.current.warnmsg("変換可能なデータは存在しません");
        //                            }
        //                            else {
        //                                if (data.master.length !== 0) {
        //                                    for (let i = 0; i < data.master.length; i++) {
        //                                        fnc.current.setMaster(data.master[i]);
        //                                    }
        //                                }
        //                                //変換できた行データを反映
        //                                data.warning.forEach(function (values) {
        //                                    let node = gridApi.getRowNode(values.rowid);
        //                                    node.setDataValue(values.col, values.value);
        //                                });
        //                                fnc.current.showconvdescription(data.warning);
        //                                gridApi.redrawRows();   //Re Render
        //                                fnc.current.success();
        //                            }
        //                            fnc.current.wait(false);
        //                        },
        //                        errmsg: "マスタコード変換に失敗しました"
        //                    }
        //                )
        //            },
        //        });
        } else {
            result.push('separator');
            result.push(
                {
                    name: '保存データに追加',
                    tooltip: '登録済の保存データに明細を追加します',
                    action: function () {
                        const selectedRows = params.api.getSelectedRows();
                        if (!selectedRows || selectedRows.length === 0) {
                            fnc.current.warnmsg("行を選択してください");
                            return;
                        }
                        const datainfo = { datatype: CELLTYPE.MASTER, dataid: "p_storage_wp", primary: false, keyinfo: props.controller, columnid: "Storage" }
                        fnc.current.searchlistopen({
                            label: "保存データ",
                            multiple: false,
                            rowmode: false,
                            data: datainfo,
                            doApply: AddStorage,
                        });
                        function AddStorage(e) {
                            fnc.current.confmsg("指定の保存データに明細を追加します。よろしいですか？", () => Apply(e.value));
                            function Apply(name) {
                                if (name === storagename) {
                                    fnc.current.warnmsg("表示中の保存データです");
                                    return;
                                }
                                var param = {
                                    controller: props.controller,
                                    key: name,
                                    rowdata: selectedRows,
                                    coldef: AGRef.current.GetshownColDef(),
                                    colinfo: columninfo,
                                    update: false
                                }
                                e.controller = props.controller;
                                fnc.current.postaxios(props.actionurl.storageadd, param,
                                    {
                                        onSuccess: function (data) {
                                            fnc.current.searchlistclose();
                                            fnc.current.success();
                                            fnc.current.wait(false);
                                        },
                                        errmsg: "登録に失敗しました"
                                    }
                                )
                            }
                        }
                    },
                });
        }

        return result;
    };
    function getMainMenuItems(params){
        var athleteMenuItems = [];

        if (params.column.colId !== "ag-Grid-AutoColumn") {
            athleteMenuItems.push({
                name: '列固定（Pin）',
                icon: copyicon(2),
                subMenu: [
                    {
                        name: '先頭',
                        checked: params.column.pinned === 'left',
                        action: function () {
                            params.api.setColumnsPinned([params.column.colId], 'left');
                        },
                    },
                    {
                        name: '末尾',
                        checked: params.column.pinned === 'right',
                        action: function () {
                            params.api.setColumnsPinned([params.column.colId], 'right');
                        },
                    },
                    {
                        name: 'No Pin',
                        tooltop: '固定されていない列',
                        checked: isEmpty(params.column.pinned),
                        action: function () {
                            params.api.setColumnsPinned([params.column.colId], 'none');
                        },
                    },
                ]
            });
            athleteMenuItems.push('separator');
        }
        athleteMenuItems.push({
            name: '列幅最適化-すべての列',
            action: () => {
                var allColumnIds = [];
                params.api.getAllGridColumns().forEach(function (column) {
                    if (column.colId !== 'grip')
                        allColumnIds.push(column.colId);
                });
                params.api.autoSizeColumns(allColumnIds, false);
            },
        });
        athleteMenuItems.push({
            name: '列幅最適化-指定列',
            action: () => {
                params.api.autoSizeColumns([params.column.colId], false);
            },
            }
        );
        if (isEnabled(params.column.colDef.enableRowGroup)) {
            athleteMenuItems.push(
                'separator',
                params.column.rowGroupActive ? 'rowUnGroup' : 'rowGroup'
            );
        }
        if (params.column.colId === "ag-Grid-AutoColumn") {
            athleteMenuItems.push(
                'separator',
                {
                    name: 'Expand(全開)',
                    action: () => {
                        params.api.expandAll();
                    },
                },
                {
                    name: 'Collapse(全閉)',
                    action: () => {
                        params.api.collapseAll();
                    },
                },
                'separator',
                {
                    name: 'Group解除',
                    action: () => {
                        params.api.setRowGroupColumns([]);
                    },
                }
            );
        }
        return athleteMenuItems;
    };
    function hdclass(params) {
        if (formstyle === null) return '#333';
        if (myfield(params.colDef.colinfo)) {
            return storagefield(params.column.colId) ? '.strheaderthema' : formstyle.header['myfd'];
        } else {
            return formstyle.header['base'];
        }
    //    if (agtheme === null) return '#333';
    //    if (myfield(params.colDef.colinfo)) {
    //        return storagefield(params.column.colId) ? '.strheaderthema' : agtheme['myfd'];
    //    } else {
    //        return agtheme['base'];
    //    }
    }
    function myfield(colinfo) {
        try {
            if (colinfo.datatype === CELLTYPE.STICKY) return true;
            if (colinfo.datatype === CELLTYPE.TAG && colinfo.columnid.indexOf('mytags') !== -1) return true;
            if (colinfo.columnid === memofield()) return true;
        } catch { }
        return false;
    }
    function storagefield(colid) {
        return (colid === "sticky" || colid === "memo");
    }
    function applycolumn() {
        //列状態を更新 ToolPanel用
        setcolumns(AGRef.current.GetApplyColumnDefs(columns));  
    }
    function coldefall() {
        let coldefs = [];
        if (listtabs.length === 0) {
            coldefs.push(AGRef.current.GetshownColDef());
        } else {
            for (let i = 0; i < listtabs.length; i++) {
                if (i.toString() === tabvalue) {
                    coldefs.push(AGRef.current.GetshownColDef());
                } else {
                    let key = formid + "_" + i + "_colstate"
                    let columns = Getstorage(corpkey, account, key);
                    if (isEmpty(columns)) {
                        coldefs.push([]);
                        continue;
                    }
                    let coldef = [];
                    columns.forEach(function (col) {
                        if (!col.hide) {
                            coldef.push(
                                {
                                    headerName: col.headerName,
                                    table: col.table,
                                    field: col.colId,
                                    width: col.width, //column.actualWidth,
                                    pinned: col.pinned ? true : false
                                });
                        }
                    });
                    coldefs.push(coldef);
                }
            }
        }
        return coldefs;
    }
    const statuspanels = props.tabs === true ? [
        {
            statusPanel: GridTab,
            align: 'left',
            key: 'GridTabKey',
            statusPanelParams: {
                tabvalue: tabvalue,
                tabChange: tabChange,
                fnc: fnc
            },
        },
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'right' },
        ] :
        [
            { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'right' },
        ];
    const toolPanels = [
        {
            id: 'columns',
            labelDefault: '',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
                suppressRowGroups: isViewStatus ? false : true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnExpandAll: true,
            },
        },
        {
            id: 'filters',
            labelKey: 'filters',
            labelDefault: '',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
        },
        {
            id: 'customStats',
            labelDefault: '',
            labelKey: 'customStats',
            iconKey: 'custom-tools',
            toolPanel: CustomToolPanel,
            toolPanelParams: {
                useSearchPanel: condition && !isEnabled(props.list),
                fnc: fnc,
                dataid: props.controller,
                subkey: props.subkey,
                type: tabvalue,
                applycolumn: applycolumn,
                getcoldef:coldefall
            },
        },
        {
            id: 'customStats2',
            labelDefault: '',
            labelKey: 'customStats',
            iconKey: 'custom-tools2',
            toolPanel: CustomToolorgPanel,
            toolPanelParams: {
                fnc: fnc,
                dataid: props.controller,
                subkey: props.subkey,
                type: tabvalue,
                savelayout: savelayout,
                calllayout: calllayout,
                entryform: props.entryform
            },
        },
    ];
    const locktoolPanels = [
        {
            id: 'filters',
            labelKey: 'filters',
            labelDefault: '',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
        },
        {
            id: 'customStats',
            labelDefault: '',
            labelKey: 'customStats',
            iconKey: 'custom-tools',
            toolPanel: CustomToolPanel,
            toolPanelParams: {
                useSearchPanel: condition && !isEnabled(props.list),
                fnc: fnc,
                dataid: props.controller,
                subkey: props.subkey,
                type: tabvalue,
                calllayout: calllayout
            },
        },
    ];

    function GroupFooterValue(params) {
        if (!isEmpty(params.value)) {
            var colinfos = params.api.columnModel.columnDefs;
                var colinfo = colinfos.find(e => e.field === params.node.field);
                if (colinfo === null) return params.value;
                if (colinfo.datatype === CELLTYPE.MASTER) {
                    let data = params.context.rowData.find(e => e[params.node.field] === params.value);
                    if (isEmpty(data)) return params.value;
                    let nm = data[params.node.field + "_nm"]
                    if (!isEmpty(nm)) {
                        return params.value + ":" + nm;
                    }
                }
        } else {
            return params.value;
        }
        return params.value;
    }

    function celStyle(p) {
        if (isEmpty(props.celStyle)) return undefined;
        return props.celStyle(p);
    }
    function cellRenderer(column) {
        if (column.datatype === CELLTYPE.TAG || column.datatype === CELLTYPE.STICKY || column.datatype === CELLTYPE.IMAGE) return TagRenderer;
        if (isViewStatus) {
            if (column.datatype === CELLTYPE.COLOR) return TagRenderer;
            return undefined;
        } else {
            return ListEditRenderer;
        }
    }

    const cellRendererParams = {
        columninfo: columninfo,
        tabvalue: tabvalue,
        suppressMouseEventHandling: function (params) {
            const target = params.event?.target;
            const isEditButton = !!target?.closest?.('[data-list-edit-trigger="true"]');
            const isSelectedRow = !!params.node?.isSelected?.();

            return isEditButton && isSelectedRow;
        },
        clicked: function (e) {
            //検索リストOPEN
            if (!isEmpty(props.QuerySearchlistOpen)) {
                props.QuerySearchlistOpen(e);
            }
            let id = e.colDef.colId;
            let result = e.colDef.colinfo;
            if (result === undefined) return;
            let tag = [];
            if (result.datatype === CELLTYPE.TAG && e.colDef.editable) {
                tag = AGRef.current.GetTagDataList(id);
            }
            if (result.datatype === CELLTYPE.MASTER || result.datatype === CELLTYPE.TAG || result.datatype === CELLTYPE.MASTERREF ||
                result.datatype === CELLTYPE.MASTERCODE || result.datatype === CELLTYPE.MASTERASST) {
                if (isEmpty(result.dataid)) {
                    fnc.current.warnmsg("システム設定を確認してください。dataidが設定されていません");
                    return;
                }
            }
            let currowid = DicVal(e.data, 'rowid', null);
            if (isEmpty(currowid)) return;
            let rowid = [e.data.rowid];
            let rows = gridApi.getSelectedRows();
            let res = rows.filter(r => r.rowid === currowid);
            if (res.length !== 0) {
                //選択行に呼出行が存在する場合選択行すべてを対象
                rowid = rows.map(function (p) { return p.rowid; });
            }
            setcolumns(AGRef.current.GetApplyColumnDefs(columns));  //列状態を更新
            fnc.current.searchlistopen({
                label: e.colDef.headerName,
                multiple: result.multiple || result.datatype === CELLTYPE.TAG || result.primary,
                rowmode: (result.multiple || result.primary) && result.datatype !== CELLTYPE.MASTERREF,
                data: result,
                rowid: rowid,
                currowid: currowid,
                taglist: tag,
                doApply: setsearchitem,
                exdataid: props.primaryid,
                rowdata: DeepCopy(e.data),
                gridApi: gridApi,
                columninfo: columninfo,
            });
        },
        deletetag: function (e, newtag) {
            let rowNode = gridApi.getRowNode(e.data.rowid);
            rowNode.setDataValue(e.colDef.colId, newtag);
        },
        imageclick: function (e,mode,src) {
            //mode=0:画像あり 1:noimage 2:未読み込み
            if (!isEmpty(props.imageclick)) props.imageclick(e, mode, src);
        }
    };
    const columnDefs = columns.map(col => {
        if (!isEmpty(col.child)) {
            // 子カラムを持つ場合（グループ列）
            return {
            ...col,
            children: col.child.map(child => ({
                ...child,
                valueParser,
                valueFormatter,
                useValueFormatterForExport: false,
                cellClassRules,
                cellEditorSelector,
                cellRenderer: cellRenderer(child),
                cellRendererParams
            }))
            };
        }

        // 子カラムなし
        return {
            ...col,
            valueParser,
            valueFormatter,
            useValueFormatterForExport: false,
            cellClassRules,
            cellEditorSelector,
            cellRenderer: cellRenderer(col),
            cellRendererParams,
            cellStyle: (p)=>celStyle(p)
        };
    });
    const cellSelection = useMemo(() => {
        return {
            handle: {
                mode: 'fill',
            },
        };
    }, []);

    function ListOptionArea() {
        if (Operation(formstatus) === OP.ENTRY) return null;
        if (!isoption) return null;
        return (
            <div style={{ marginTop:5 }}>
                <EntryBase
                    fnc={fnc}
                    textfields={listoptionFields}
                    panel={optpanel}
                    entrydataRef={listoptionRef}
                    ValueChanged={OptionChanged}
                    layoutlock={true}
                />
            </div>
        );
    }
    return (
        <div style={{ backgroundColor: bodytheme.back, color: bodytheme.color }}>
            {opentheme ? <Theme formid={formid} fnc={fnc} /> : null}
            <ComFunc ref={fnc} />
            <Header
                category={category}
                title={title}
                menuClick={showmenu}
                showsearchpanel={false}
                close={storageclose}
                storageaction={storageaction}
            />
            <div style={{ display: isEnabled(props.blank)  ?'none':'', width: '100%', paddingLeft: 5}}>
                <div style={{ display: 'inline-block' }}>
                    <StatusNav
                        onStatusChange={callChangeStatus}
                        onMenuClick={MenuClick}
                        existform={props.entryform}
                        masonry={props.masonry}
                        type={listtype}
                        upload={props.actionurl === undefined ? undefined : props.actionurl.upload}
                        saveas={props.actionurl === undefined ? undefined : props.actionurl.saveas}
                        menu={navmenu}
                        suppressaction={props.suppressaction}
                        hiddencmd={hiddencmd }
                        mysave={mysave}
                        list={props.list}
                        entryonly={props.entryonly}
                        entrystatusoptions={props.entrystatusoptions}
                        entrystatusaction={props.entrystatusaction}
                        notshowstatus={isEnabled(props.insertonly) || notshowstatus}
                        usecondition={isEnabled(props.usecondition)}
                        conditioncancelenabled={conditionCancelEnabled}
                        execute={ListExecute}
                    />
                </div>
                {/* StatusNav と同じ行に置く画面固有の拡張領域(未指定の画面では何も描画しない) */}
                {props.statusnavextra === undefined || props.statusnavextra === null ? null :
                    <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                        {props.statusnavextra}
                    </div>
                }
                <div style={{ display: isListStatus ? 'inline-block' : 'none', marginLeft: 20, verticalAlign:'top' }}>
                    <Paper component="div" className={classes.root} style={{ width: windowDimensions.width - 250 }}>
                        <span style={{ maxwidth: '70%' }}>
                            {searchtaglist.map(tag => (
                                <Chip
                                    size="small"
                                    label={tag.tag}
                                    onDelete={() => removeSearchTag(tag)}
                                    onClick={() => changeSearchTag(tag)}
                                    style={{ backgroundColor: tag.mode === 1 ? 'firebrick' : 'aquamarine', color: "white" }}
                                    className={classes.chip}
                                />
                                ))}
                        </span>
                        <InputBase
                            className={classes.input}
                            value={searchword }
                            placeholder="検索ワード"
                            onChange={(e) => FilterSearch(e.target.value)}
                        />
                        <span style={{ cursor: 'pointer', marginRight: 20, paddingTop: 10 }} onClick={() => FilterSearch("")}>
                            <i class="material-icons delete">close</i>
                        </span>
                        <IconButton size="small" onClick={AddSearchTag} title={"検索タグ"} >
                            <Icon>sell</Icon>
                        </IconButton>
                        {condition ?
                            <React.Fragment>
    　                      <Divider className={classes.divider} orientation="vertical" />
                                <IconButton size="small" onClick={OpenSearchpanel} title={"検索条件"} >
                            <Icon>search</Icon>
                            </IconButton>
                            </React.Fragment>
                            :null
                        }
                    </Paper>
                </div>
            </div>

            {/*List Option*/}
            <ListOptionArea/>

            <div style={{ display: isEnabled(props.blank)  ? 'none' : '', height: windowDimensions.height - ajustH, width: '100%', marginTop: 5, position: 'relative' }}>
                <div className="ag-theme-balham masterlayout-grid" style={{
                    height: '100%', width: '100%',
                    display: isListStatus && !isEnabled(props.entryonly) ? '' : 'none',
                    '--master-rownum-background': formstyle?.header?.back,
                    '--master-rownum-color': formstyle?.header?.color,
                }}>
                    <AgGridReact
                        theme={themeBalham}
                        onGridReady={onGridReady}
                        rowNumbers={{
                            headerStyle: {
                                backgroundColor: formstyle?.header?.back,
                                color: formstyle?.header?.color
                            }
                        }}
                        cellSelection={cellSelection}
                        getRowId={params => params.data.rowid}
                        ref={gridRef}
                        modules={[AllCommunityModule, AllEnterpriseModule]}
                        icons={icons}
                        sideBar={{
                            toolPanels: listlock ? locktoolPanels : toolPanels,
                        }}
                        aggFuncs={aggFuncs}
                        groupRowsSticky={true}
                        getRowHeight={getRowHeight}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        columnMenu="legacy"
                        autoGroupColumnDef={{ cellClass: function (params) { return params.node.group ? 'exag_rowgroup' : ''; } }}
                        excelStyles={excelStyles}
                        defaultColDef={{
                            filter: true,
                            sortable: true,
                            resizable: true,
                            editable: false,
                            filterType:"multi",
                            menuTabs: ['filterMenuTab', 'generalMenuTab'],
                            tooltipValueGetter: (params) => {
                                if (params.column.colId.indexOf('tag') !== -1) return params.value;
                                if (!isEmpty(columninfo)) {
                                    let col = columninfo.find(e => e.columnid === params.column.colId);
                                    if (isEmpty(col)) {
                                        return null;
                                    }
                                    if (col.datatype === CELLTYPE.TEXTAREA || col.datatype === CELLTYPE.TEXT) return params.value;
                                }
                                return null;
                            },
                            headerClass: function (params) {
                                return hdclass(params);
                            },
                       }}
                        defaultColGroupDef={{
                            headerClass: function (params) {
                                return hdclass(params);
                            }
                        }}
                        enableBrowserTooltips={true}
                        tooltipShowDelay={0}
                        getRowNodeId={RowNodeId}
                        getRowStyle={getRowStyle}
                        multiSortKey={'ctrl'}
                        context={gridContext}
                        enableRangeSelection={true}
                        suppressMultiRangeSelection={true}
                        suppressMovableColumns={listlock}
                        suppressDragLeaveHidesColumns={listlock}
                        enableFillHandle={!isViewStatus}
                        fillHandleDirection={'y'}
                        rowSelection={'multiple'}
                        getMainMenuItems={getMainMenuItems}
                        getContextMenuItems={getContextMenuItems}
                        isExternalFilterPresent={isExternalFilterPresent}
                        doesExternalFilterPass={doesExternalFilterPass}
                        onGridColumnsChanged={GridColumnsChanged}
                        onRowDataUpdated={RowDataUpdated}
                        onBodyScrollEnd={BodyScrollEnd}
                        onPasteStart={PasteStart}
                        processDataFromClipboard={processDataFromClipboard}
                        //onCellEditingStarted={() => setcolumns(AGRef.current.GetApplyColumnDefs(columns))}
                        onColumnGroupOpened={ColumnGroupOpened}
                        onCellValueChanged={onCellValueChanged}
                        onColumnVisible={ColumnVisible}
                        onColumnPinned={ColumninfoAppy}
                        onColumnMoved={ColumninfoAppy}
                        onColumnResized={ColumnResized}
                        onCellDoubleClicked={onCellDoubleClicked}
                        onCellClicked={onCellClicked }
                        onFilterChanged={onfilterChanged}
                        applyColumnDefOrder={true}
                        pagination={false}
                        undoRedoCellEditing={true}
                        undoRedoCellEditingLimit={9}
                        statusBar={{
                            statusPanels: statuspanels,
                        }}
                        localeText={{
                            cut: '切り取り',
                            paste: '貼り付け',
                            copy: 'コピー',
                            copyWithHeaders: 'ヘッダ付きコピー',
                       }}
                    >
                    </AgGridReact>
                </div>
                {isListStatus ? null :
                    <React.Fragment>
                        {props.children}
                    </React.Fragment>
                }
            </div>

            < MainMenu
                show={menuopen}
                isTop={false}
                controller={props.controller}
                subkey={props.subkey}
                doClose={closemenu}
                fnc={fnc}
            />
            <StickyList/>
            <DatePicker />
            <ColorPicker />
            <WashPicker />
            <SearchSKU />
            <SearchList inTag={false}/>
           {/*検索TAG用*/}
            <SearchList inTag={true}/>
            <SearchPanel
                open={searchpanelopen}
                onClose={()=>setsearchpanelopen(false)}
                controller={props.controller}
                subkey={props.subkey}
                columninfo={columninfo}
                fnc={fnc.current}
                items={searchitems}
                savekey={props.controller}
                doApply={searchexecute }
            />
            {props.masonry ?
                <MasonryForm
                    sticky={stickyfield()}
                    memo={memofield()}
                    pkey={primarykey()}
                    columns={columns}
                    fnc={fnc}
                    show={EntryCall}
                    setentryrow={setentryrow}
                    actionurl={props.actionurl}
                    savefinally={entrysavefinally }
                />
                : null}
            <Backdrop className={classes.backdrop} open={wait}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <WaitCursor active={waitcursor} />
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={edittool !== 0}
                ContentProps={{
                    className: classes.snackbaredittool
                }}
                message={
                    <div>
                        <div>
                            {edittool === 1 ? "検索" : "置換"}
                            <div style={{ position: 'absolute', top: 5, right:10 }}>
                                <IconButton
                                    color="inherit"
                                    size="small"
                                    onClick={() => setedittool(0)}
                                >
                                <Icon>close</Icon>
                                </IconButton>
                            </div>
                        </div>
                        <div style={{ marginTop:20 }}>
                            <TextField
                                inputRef={findwordRef}
                                variant="standard" size="small" placeholder="検索ワード"
                                hiddenLabel
                                inputProps={{ style: { fontSize: 12, width:200 } }}
                            />
                            <Button variant="text" size="small" onClick={SheetFind }>検索</Button>
                        </div>
                        {edittool === 1 ?
                            <div>
                                <FormControlLabel
                                    control={<Checkbox size="small" color="default" inputRef={matchRef} />}
                                    label={<span className={classes.label} title="完全一致するセルのみ検索">完全一致</span>}
                                />
                                {Defaultrange?
                                    <FormControlLabel
                                        control={<Checkbox size="small" color="default" inputRef={rangeRef} defaultChecked />}
                                    label={<span className={classes.label} title="選択範囲のセルのみ検索">選択範囲</span>}
                                />:
                                    <FormControlLabel
                                        control={<Checkbox size="small" color="default" inputRef={rangeRef} />}
                                    label={<span className={classes.label} title="選択範囲のセルのみ検索">選択範囲</span>}
                                    />
                                }
                                <Checkbox title="検索方向" color="default" icon={<Icon>arrow_downward</Icon>} checkedIcon={<Icon>arrow_upward</Icon>} inputRef={directionRef} />
                            </div>
                            :
                            <div>
                            <div >
                            <TextField
                                inputRef={replacewordRef}
                                variant="standard" size="small" placeholder="置換後ワード"
                                hiddenLabel
                                inputProps={{ style: { fontSize: 12, width: 200 } }}
                            />
                            <Button variant="text" size="small" onClick={SheetReplace} >置換</Button>
                            </div>
                            <div>
                                <FormControlLabel
                                    control={<Checkbox size="small" color="default" inputRef={matchRef} />}
                                    label={<span className={classes.label} title="完全一致するセルのみ検索">完全一致</span>}
                                />
                                    {Defaultrange ?
                                        <FormControlLabel
                                            control={<Checkbox size="small" color="default" inputRef={rangeRef} defaultChecked />}
                                            label={<span className={classes.label} title="選択範囲のセルのみ検索">選択範囲</span>}
                                        /> :
                                        <FormControlLabel
                                            control={<Checkbox size="small" color="default" inputRef={rangeRef} />}
                                            label={<span className={classes.label} title="選択範囲のセルのみ検索">選択範囲</span>}
                                        />
                                    }
                                <Checkbox title="検索方向" color="default" icon={<Icon>arrow_downward</Icon>} checkedIcon={<Icon>arrow_upward</Icon>} inputRef={directionRef} />
                            </div>
                            <div >
                                <Button variant="text" size="small" onClick={SheetReplaceAll}>すべて置換</Button>
                            </div>
                            </div>
                        }
                    </div>
                }
            />
           <Snackbar
               open={resultsuccess}
               ContentProps={{
                   "aria-describedby": "message-id",
                   className: classes.snackbarStyleViaContentProps
               }}
               autoHideDuration={6000}
               onClose={() => dispatch(success(false))}
                message={<div><i class="material-icons delete">done_all</i><span style={{ marginLeft: 20 }}>{successmsg}</span></div>}
           />
           <Snackbar
               open={resultwarnning}
               message={
                   <React.Fragment>
                       <div>
                           <span>{warnmessage}</span>
                       </div>
                       <div style={{ maxHeight: 100, overflow: 'auto', marginTop:5 }}>
                       {warndescription.map(description => (
                           <div>
                               <IconButton
                                   color="inherit"
                                   sx={{ mr: 5 }}
                                   size="small"
                                   onClick={() => LinkField(description)}
                               >
                                   <span class="material-icons editlink">announcement</span>
                               </IconButton>
                               <span>{description.message}</span>
                           </div>
                       ))}
                        </div>
                   </React.Fragment>
               }
               action={
                   <React.Fragment>
                       <IconButton
                            color="inherit"
                           sx={{ p: 0.5 }}
                           onClick={() => dispatch(warnning(false))}
                       >
                       <Icon>close</Icon>
                       </IconButton>
                   </React.Fragment>
               }
           />
             <AGFunc
                ref={AGRef}
                gridApi={gridApi}
                gridColumnApi={gridColumnApi}
                gridid="main"
                storekey={storekey}
                stickykey={stickykey}
            />
            <FormDlg classes={classes} fnc={fnc} />
            <Popuptext />
          <MsgBox/>
           <input
               hidden
               ref={uploadRef}
               type="file"
               onChange={onFileInputChange}
           />
            <input
                hidden
                multiple
                ref={upload2Ref}
                type="file"
                onChange={onFileUploadChange}
            />
            <ImageDialog open={imgdlgopen} handleClose={setimgdlgopen} />
       </div>
    );

});

export default MasterLayout;
